
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aMyAY", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBanner", () => $2c83853224acd4a8$export$48911bd645a2a0a2);
/* CookieConsentBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $gMRLG = parcelRequire("gMRLG");

var $3zmAJ = parcelRequire("3zmAJ");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");


var $lwlmQ = parcelRequire("lwlmQ");
const $2c83853224acd4a8$export$48911bd645a2a0a2 = ()=>{
    const [{ height: height }] = (0, $lwlmQ.useCookieConsentBannerSettings)();
    const { onDismiss: onDismiss, setHeight: setHeight } = (0, $lwlmQ.useCookieConsentBannerSettingsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const ref = (0, $eJOHy.useRef)(null);
    // START - Analytics
    // Fire analytics if the banner height changes (and not due to a resize)
    const previousHeight = (0, $eJOHy.useRef)(height);
    const hasFiredAnalytics = (0, $eJOHy.useRef)(false);
    const hasResized = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('killswitch-analytics-ssr-cookie-consent-banner') || !(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return;
        if (!hasResized.current && height !== previousHeight.current && !hasFiredAnalytics.current) {
            // Fire analytics event when the banner height changes (and not from a resize) so we know how often it happens
            // Eg because the default banner height differs from the actual banner height
            // This can cause a layout shift if the banner height is not set correctly and thus impact VC90
            // However, this may only be an edge case, so we want to verify how often it happens with these analytics before we invest effort into fixing it
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'heightChanged',
                actionSubject: 'cookieConsentBanner',
                attributes: {
                    height: height,
                    previousHeight: previousHeight.current
                }
            }), 'cookieConsentBanner heightChanged');
            hasFiredAnalytics.current = true;
            previousHeight.current = height;
        }
    }, [
        createAnalyticsEvent,
        height
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('killswitch-analytics-ssr-cookie-consent-banner') || !(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return;
        const onResize = ()=>{
            hasResized.current = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResize);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
        };
    });
    // END - Analytics
    // banner height is set either due to screen width changes or consent banner finishes rendering
    const setBannerHeight = (0, $fAZgY.useCallbackWithCondition)(()=>{
        ref.current && setHeight(ref.current.clientHeight);
    }, [
        setHeight
    ], ()=>(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner'));
    // throttled banner height setter is used for dynamic banner height when screen width changes
    const throttledSetBannerHeight = (0, $fAZgY.useMemoWithCondition)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setBannerHeight, 50), [
        setBannerHeight
    ], ()=>(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner'));
    (0, $eJOHy.useEffect)(()=>{
        const action = 'rendered';
        const actionSubject = 'cookieConsentBanner';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $gCeeo.fireUIAnalytics)(event, `${actionSubject} ${action}`);
    }, [
        createAnalyticsEvent
    ]);
    const onConsentBannerBailOut = (0, $eJOHy.useCallback)(()=>{
        const actionSubject = 'consentBanner';
        const action = 'bailedOut';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $gCeeo.fireTrackAnalytics)(event, `${actionSubject} ${action}`);
        // consider banner as dismissed if it reports a bail out
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: throttledSetBannerHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            !height && "_3um015vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3zmAJ.ConsentBanner), {
        // If you pass localConsentMode=true here you will need to change the logic in
        // jira/src/packages/platform/ui/banners/cookie-consent/src/controllers/index.tsx shouldRenderBanner
        // as it expects that localConsentMode is false
        onHide: onDismiss,
        onShow: setBannerHeight,
        minWidth: (0, $5dc1b04ccd518917$export$ff6e18f7d82b549c),
        onConsentBannerBailOut: onConsentBannerBailOut,
        product: "Jira"
    })));
};

});
parcelRegister("gMRLG", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1DXAa = parcelRequire("1DXAa");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1DXAa.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1DXAa", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $cca7bb4179e40d90$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $cca7bb4179e40d90$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("3zmAJ", function(module, exports) {

$parcel$export(module.exports, "ConsentBanner", () => $4d234cb1ea10a96d$export$903b95b8397e77e9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $101p7 = parcelRequire("101p7");

var $eGOwo = parcelRequire("eGOwo");

var $60vYG = parcelRequire("60vYG");

var $8H9v6 = parcelRequire("8H9v6");
const $4d234cb1ea10a96d$export$903b95b8397e77e9 = (props)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $eGOwo.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $101p7.FlagsProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8H9v6.ConsentBannerImpl), {
                ...props
            })
        })
    });
};

});
parcelRegister("8H9v6", function(module, exports) {

$parcel$export(module.exports, "ConsentBannerImpl", () => $b8f2ad62d045af2c$export$24af610f9b900e82);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $101p7 = parcelRequire("101p7");

var $eGOwo = parcelRequire("eGOwo");

var $45MTl = parcelRequire("45MTl");

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $2wQka = parcelRequire("2wQka");

var $60vYG = parcelRequire("60vYG");

var $2hz3A = parcelRequire("2hz3A");

var $aqhop = parcelRequire("aqhop");
var $2p0jb = parcelRequire("2p0jb");

var $4kOzQ = parcelRequire("4kOzQ");

var $6KMc4 = parcelRequire("6KMc4");

var $2cqhT = parcelRequire("2cqhT");

var $bydzT = parcelRequire("bydzT");

var $3TuNG = parcelRequire("3TuNG");

var $fN2qH = parcelRequire("fN2qH");

var $d5pSq = parcelRequire("d5pSq");
const $b8f2ad62d045af2c$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight })=>{
    const firstRender = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $lgusX.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $aqhop.deleteCookie)((0, $2hz3A.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        (0, $9SIye.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $eJOHy.useState)(false);
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $101p7.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $bydzT.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $fN2qH.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender
    });
    const closePreferenceModal = (0, $eJOHy.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $eJOHy.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $eJOHy.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $lgusX.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $eJOHy.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...(0, $45MTl.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $6KMc4.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $6KMc4.i18n).successFlagTitle)
        });
        else showFlag({
            ...(0, $45MTl.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $6KMc4.i18n).successFlagDescription),
            title: intl.formatMessage((0, $6KMc4.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            ...(0, $45MTl.errorToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $6KMc4.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $6KMc4.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $eJOHy.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $lgusX.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $4kOzQ.updatePreferences)((0, $2hz3A.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $lgusX.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2hz3A.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $eJOHy.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $lgusX.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $4kOzQ.updatePreferences)((0, $2hz3A.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $lgusX.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2hz3A.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $eJOHy.useCallback)(()=>{
        (0, $lgusX.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    const prevShowBanner = (0, $d5pSq.default)(showBanner);
    (0, $eJOHy.useEffect)(()=>{
        if (showBanner && (!prevShowBanner || (0, $eGOwo.fg)('platform_fix_blank_cookie_banner_bug'))) onShow?.();
        else if (!showBanner && (prevShowBanner || (0, $eGOwo.fg)('platform_fix_blank_cookie_banner_bug'))) onHide?.();
    }, [
        showBanner,
        prevShowBanner,
        onShow,
        onHide
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $101p7.FlagsProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2wQka.BSCIntlProvider), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3TuNG.PresentationalConsentBanner), {
                    onClickOnlyNecessary: onClickOnlyNecessary,
                    onClickAcceptAll: onClickAcceptAll,
                    onClickPreferences: onClickPreferences,
                    onClickTrackingNoticeLink: onClickTrackingNoticeLink,
                    minWidth: minWidth,
                    newMinHeight: newMinHeight
                }),
                isPreferencesModalOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2cqhT.PreferenceModal), {
                    onClose: closePreferenceModal,
                    onSubmit: onPreferenceModalSubmit,
                    showSuccessFlag: showSuccessFlag,
                    showErrorFlag: showErrorFlag
                })
            ]
        })
    });
};

});
parcelRegister("45MTl", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $1533200a48fc3bd9$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $1533200a48fc3bd9$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $1533200a48fc3bd9$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $1533200a48fc3bd9$export$b56198a940066d8f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

var $eGOwo = parcelRequire("eGOwo");


var $aTMPB = parcelRequire("aTMPB");
const $1533200a48fc3bd9$var$ErrorWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).error),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$WarningWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).warning),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$InfoWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        color: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).info),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$SuccessWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
        color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).success),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$WarningWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$InfoWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("aTMPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86edcbb90c3443de$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $86edcbb90c3443de$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $86edcbb90c3443de$export$2e2bcd8739ae039 = $86edcbb90c3443de$var$messages;

});


parcelRegister("2wQka", function(module, exports) {

$parcel$export(module.exports, "BSCIntlProvider", () => $944b019a0ba20c85$export$9aa38aed134c207f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $h1MSW = parcelRequire("h1MSW");

var $fvLXK = parcelRequire("fvLXK");
const $944b019a0ba20c85$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $h1MSW.default),
        loaderFn: (0, $fvLXK.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("h1MSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5aca85896da296$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5e5aca85896da296$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved'
};

});

parcelRegister("fvLXK", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $cef63c08272a18f3$export$2b153a2030b0feb2);
const $cef63c08272a18f3$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});


parcelRegister("aqhop", function(module, exports) {

$parcel$export(module.exports, "deleteCookie", () => $0925738c9927a3a5$export$b43e45590305ffaa);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");
const $0925738c9927a3a5$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    else try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("4kOzQ", function(module, exports) {

$parcel$export(module.exports, "updatePreferences", () => $5c06712614aa923d$export$7bb3e177c1a1e841);

var $9SIye = parcelRequire("9SIye");

var $2hz3A = parcelRequire("2hz3A");

var $6T1aH = parcelRequire("6T1aH");

var $3UTYZ = parcelRequire("3UTYZ");

var $5Qndl = parcelRequire("5Qndl");

var $eCCyA = parcelRequire("eCCyA");
const $5c06712614aa923d$var$emptyDisplayedTextMap = {
    [(0, $6T1aH.PreferenceCategory).Analytics]: '',
    [(0, $6T1aH.PreferenceCategory).Functional]: '',
    [(0, $6T1aH.PreferenceCategory).Marketing]: '',
    [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $6T1aH.PreferenceCategory).Unknown]: ''
};
async function $5c06712614aa923d$export$7bb3e177c1a1e841(preferences, displayedTextMap = $5c06712614aa923d$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $9SIye.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $eCCyA.packUserPreferences)(preferences);
        (0, $5Qndl.setStrictlyNecessaryCookie)((0, $2hz3A.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $3UTYZ.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("3UTYZ", function(module, exports) {

$parcel$export(module.exports, "setConsentToken", () => $b07a454923b8c45b$export$fbf549fe6f0e91dc);

var $eGOwo = parcelRequire("eGOwo");

var $60vYG = parcelRequire("60vYG");

var $a3JoR = parcelRequire("a3JoR");

var $eLZEM = parcelRequire("eLZEM");

var $6T1aH = parcelRequire("6T1aH");

var $7nXZH = parcelRequire("7nXZH");

var $eCCyA = parcelRequire("eCCyA");

var $23WXv = parcelRequire("23WXv");
const $b07a454923b8c45b$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
        // On a successful save, transform the prefs object into a formatted consentToken bit string
        // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
        const consentToken = (0, $eCCyA.packUserPreferences)(mergedPrefs);
        // Check if the token is prefetched and set to default.
        if (usingPrefetchedData && (0, $eLZEM.checkIfTokenIsDefault)(consentToken)) return;
        if (usingPrefetchedData) (0, $23WXv.onlySetFallbackIfDifferent)(consentToken);
        else (0, $7nXZH.setConsentTokenFallbackCookie)(consentToken);
        (0, $7nXZH.setConsentTokenCookie)(consentToken);
        (0, $7nXZH.setShouldShowBannerCookie)(consentToken);
    } else {
        // On a successful save, transform the prefs object into a formatted consentToken bit string
        // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
        const consentToken = (0, $eCCyA.packUserPreferences)(mergedPrefs);
        // If the token is prefetched and a default, we should rely on the existing cookie data rather than re-setting
        // cookies that are already set
        const tokenIsPrefetchedDefault = usingPrefetchedData && (0, $eLZEM.checkIfTokenIsDefault)(consentToken);
        if (!tokenIsPrefetchedDefault) {
            if (usingPrefetchedData) // If the fallback token already exists, we don't want to nuke the expiration inadvertently (since this happens on every page load).
            (0, $23WXv.onlySetFallbackIfDifferent)(consentToken);
            else // This has originated from a user saving their consents in the UI, so set a fallback to their new consents immediately.
            (0, $7nXZH.setConsentTokenFallbackCookie)(consentToken);
            (0, $7nXZH.setConsentTokenCookie)(consentToken);
            (0, $7nXZH.setShouldShowBannerCookie)(consentToken);
        }
    }
};
const $b07a454923b8c45b$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $eLZEM.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $eLZEM.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $eCCyA.packUserPreferences)({
        ...mergedPrefs,
        [(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $60vYG.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $23WXv.onlySetFallbackIfDifferent)(consentToken);
        (0, $7nXZH.setConsentTokenCookie)(consentToken);
        (0, $7nXZH.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $60vYG.Logger).error('Token failed to save');
    (0, $23WXv.onlySetFallbackIfDifferent)(consentToken);
    (0, $7nXZH.setShouldShowBannerCookie)(consentToken);
};
const $b07a454923b8c45b$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $23WXv.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $a3JoR.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $b07a454923b8c45b$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $b07a454923b8c45b$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("23WXv", function(module, exports) {

$parcel$export(module.exports, "mergeConsentUpdates", () => $944ec044859e24fe$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $944ec044859e24fe$export$a023a0b818522757);

var $2hz3A = parcelRequire("2hz3A");

var $6T1aH = parcelRequire("6T1aH");

var $2p0jb = parcelRequire("2p0jb");

var $7nXZH = parcelRequire("7nXZH");

var $eCCyA = parcelRequire("eCCyA");
const $944ec044859e24fe$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $6T1aH.PreferenceCategory).StrictlyNecessary],
        [(0, $6T1aH.PreferenceCategory).Functional]: updatedPreferences[(0, $6T1aH.PreferenceCategory).Functional],
        [(0, $6T1aH.PreferenceCategory).Analytics]: updatedPreferences[(0, $6T1aH.PreferenceCategory).Analytics],
        [(0, $6T1aH.PreferenceCategory).Marketing]: updatedPreferences[(0, $6T1aH.PreferenceCategory).Marketing],
        [(0, $6T1aH.PreferenceCategory).Unknown]: updatedPreferences[(0, $6T1aH.PreferenceCategory).Unknown]
    };
};
const $944ec044859e24fe$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $944ec044859e24fe$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $eCCyA.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $2hz3A.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$944ec044859e24fe$var$pruneLegacyProperties(updatedPreferences),
            ...$944ec044859e24fe$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $2hz3A.DEFAULT_PREFERENCES),
            ...$944ec044859e24fe$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $2hz3A.DEFAULT_PREFERENCES),
        ...$944ec044859e24fe$var$pruneLegacyProperties(updatedPreferences),
        ...$944ec044859e24fe$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $944ec044859e24fe$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $7nXZH.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("6KMc4", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $f4fb0259231dc630$export$a7357cdd1f0b0168);

var $7qGN1 = parcelRequire("7qGN1");
const $f4fb0259231dc630$export$a7357cdd1f0b0168 = (0, $7qGN1.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("2cqhT", function(module, exports) {

$parcel$export(module.exports, "PreferenceModal", () => $9f986693eebce072$export$94c5684831c222e7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");

var $2hz3A = parcelRequire("2hz3A");

var $4kOzQ = parcelRequire("4kOzQ");

var $QgCYl = parcelRequire("QgCYl");

var $bydzT = parcelRequire("bydzT");
const $9f986693eebce072$export$94c5684831c222e7 = (props)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $eGOwo.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9f986693eebce072$export$30df3cfccbe10e6e, {
        ...props
    });
};
const $9f986693eebce072$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag })=>{
    const [isModalOpen, setIsModalOpen] = (0, $eJOHy.useState)(true);
    const isEventSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $lgusX.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $bydzT.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $2hz3A.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $eJOHy.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $lgusX.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $4kOzQ.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $lgusX.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $60vYG.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isModalOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $QgCYl.PresentationalPreferenceModal), {
            onSubmit: handleOnSubmit,
            onClose: onClose,
            setIsOpen: setIsModalOpen,
            preferences: preferences ?? (0, $2hz3A.ONLY_NECESSARY_PREFERENCES),
            setPreferencesData: setPreferencesData
        })
    });
};

});
parcelRegister("QgCYl", function(module, exports) {

$parcel$export(module.exports, "PresentationalPreferenceModal", () => $4e7e3bf1476f7b68$export$9921ee7829a3ba4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $etNo6 = parcelRequire("etNo6");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $goZPP = parcelRequire("goZPP");

var $3L3Os = parcelRequire("3L3Os");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lgusX = parcelRequire("lgusX");

var $lsQfa = parcelRequire("lsQfa");

var $6T1aH = parcelRequire("6T1aH");

var $ANFiK = parcelRequire("ANFiK");

var $csN0I = parcelRequire("csN0I");
const $4e7e3bf1476f7b68$var$categoryNameStyles = (0, $1DXK0.xcss)({
    fontWeight: 'font.weight.bold'
});
const $4e7e3bf1476f7b68$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $csN0I.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $csN0I.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $csN0I.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = (0, (/*@__PURE__*/$parcel$interopDefault($etNo6))).renderToStaticMarkup(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    // This outputs an encoded string that jacks up apostrophes, so clean 'em up
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $4e7e3bf1476f7b68$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $6T1aH.PreferenceCategory).Functional,
            title: (0, $csN0I.i18n).functionalOption,
            description: (0, $csN0I.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $6T1aH.PreferenceCategory).Analytics,
            title: (0, $csN0I.i18n).analyticalOption,
            description: (0, $csN0I.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $6T1aH.PreferenceCategory).Marketing,
            title: (0, $csN0I.i18n).marketingOption,
            description: (0, $csN0I.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $lsQfa.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $4e7e3bf1476f7b68$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $4e7e3bf1476f7b68$var$categoryNameStyles,
                children: translatedTitle
            }),
            descriptionElement: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                children: translatedDescription
            }),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $4e7e3bf1476f7b68$var$noop = ()=>{};
const $4e7e3bf1476f7b68$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $4e7e3bf1476f7b68$var$noop, onSubmit: onSubmit = $4e7e3bf1476f7b68$var$noop, onClose: onClose = $4e7e3bf1476f7b68$var$noop, setIsOpen: setIsOpen = $4e7e3bf1476f7b68$var$noop })=>{
    const intl = (0, $lRq8t.default)();
    const onCloseModal = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $eJOHy.useCallback)(()=>{
        onCloseModal();
        (0, $lgusX.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $eJOHy.useCallback)(()=>{
        onCloseModal();
        (0, $lgusX.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $eJOHy.useCallback)(()=>{
        (0, $lgusX.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $eJOHy.useMemo)(()=>{
        return $4e7e3bf1476f7b68$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $eJOHy.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
            onClose: onClickBackground,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
                onSubmit: handleSubmission,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                        ...(0, $csN0I.i18n).title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                ...(0, $csN0I.i18n).summaryDescription,
                                                values: {
                                                    link: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lL4G9.default), {
                                                        href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                        target: "_blank",
                                                        onClick: onClickTrackingNoticeLink,
                                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                            ...(0, $csN0I.i18n).trackingLink
                                                        })
                                                    })
                                                },
                                                tagName: 'p'
                                            }),
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                ...(0, $csN0I.i18n).strictDescription,
                                                values: {
                                                    bold: (msg)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                                            weight: "bold",
                                                            children: msg
                                                        })
                                                },
                                                tagName: 'p'
                                            })
                                        ]
                                    }),
                                    cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ANFiK.CookieCategorySection), {
                                                category: category,
                                                titleElement: titleElement,
                                                titleString: titleString,
                                                descriptionElement: description,
                                                isChecked: (preferences && preferences[category]) ?? false,
                                                setPreferencesData: setPreferencesData
                                            })
                                        }, index))
                                ]
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                                        appearance: "subtle",
                                        onClick: onClickCancel,
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                            ...(0, $csN0I.i18n).cancelBtn
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                                        type: "submit",
                                        appearance: "primary",
                                        onClick: handleSubmission,
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                            ...(0, $csN0I.i18n).confirmBtn
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("etNo6", function(module, exports) {

$parcel$export(module.exports, "version", () => $a8aa1580d62bc9be$export$83d89fbfd8236492, (v) => $a8aa1580d62bc9be$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $a8aa1580d62bc9be$export$80e7718417253a51, (v) => $a8aa1580d62bc9be$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $a8aa1580d62bc9be$export$eb3a06aef9e6ee51, (v) => $a8aa1580d62bc9be$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $a8aa1580d62bc9be$export$307591e98609eddd, (v) => $a8aa1580d62bc9be$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $a8aa1580d62bc9be$export$b23711c915539651, (v) => $a8aa1580d62bc9be$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $a8aa1580d62bc9be$export$7020a3240b287705, (v) => $a8aa1580d62bc9be$export$7020a3240b287705 = v);
var $a8aa1580d62bc9be$export$83d89fbfd8236492;
var $a8aa1580d62bc9be$export$80e7718417253a51;
var $a8aa1580d62bc9be$export$eb3a06aef9e6ee51;
var $a8aa1580d62bc9be$export$307591e98609eddd;
var $a8aa1580d62bc9be$export$b23711c915539651;
var $a8aa1580d62bc9be$export$7020a3240b287705;
'use strict';
var $a8aa1580d62bc9be$var$l, $a8aa1580d62bc9be$var$s;

$a8aa1580d62bc9be$var$l = (parcelRequire("dqBRj"));

$a8aa1580d62bc9be$var$s = (parcelRequire("tjq0h"));
$a8aa1580d62bc9be$export$83d89fbfd8236492 = $a8aa1580d62bc9be$var$l.version;
$a8aa1580d62bc9be$export$80e7718417253a51 = $a8aa1580d62bc9be$var$l.renderToString;
$a8aa1580d62bc9be$export$eb3a06aef9e6ee51 = $a8aa1580d62bc9be$var$l.renderToStaticMarkup;
$a8aa1580d62bc9be$export$307591e98609eddd = $a8aa1580d62bc9be$var$l.renderToNodeStream;
$a8aa1580d62bc9be$export$b23711c915539651 = $a8aa1580d62bc9be$var$l.renderToStaticNodeStream;
$a8aa1580d62bc9be$export$7020a3240b287705 = $a8aa1580d62bc9be$var$s.renderToReadableStream;

});
parcelRegister("dqBRj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $9c6b1212f20a86b6$export$307591e98609eddd, (v) => $9c6b1212f20a86b6$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $9c6b1212f20a86b6$export$eb3a06aef9e6ee51, (v) => $9c6b1212f20a86b6$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $9c6b1212f20a86b6$export$b23711c915539651, (v) => $9c6b1212f20a86b6$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $9c6b1212f20a86b6$export$80e7718417253a51, (v) => $9c6b1212f20a86b6$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $9c6b1212f20a86b6$export$83d89fbfd8236492, (v) => $9c6b1212f20a86b6$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c6b1212f20a86b6$export$307591e98609eddd;
var $9c6b1212f20a86b6$export$eb3a06aef9e6ee51;
var $9c6b1212f20a86b6$export$b23711c915539651;
var $9c6b1212f20a86b6$export$80e7718417253a51;
var $9c6b1212f20a86b6$export$83d89fbfd8236492;
'use strict';

var $eJOHy = parcelRequire("eJOHy");
function $9c6b1212f20a86b6$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9c6b1212f20a86b6$var$p = Object.prototype.hasOwnProperty, $9c6b1212f20a86b6$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9c6b1212f20a86b6$var$ha = {}, $9c6b1212f20a86b6$var$ia = {};
function $9c6b1212f20a86b6$var$ja(a) {
    if ($9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$ia, a)) return !0;
    if ($9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$ha, a)) return !1;
    if ($9c6b1212f20a86b6$var$fa.test(a)) return $9c6b1212f20a86b6$var$ia[a] = !0;
    $9c6b1212f20a86b6$var$ha[a] = !0;
    return !1;
}
function $9c6b1212f20a86b6$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $9c6b1212f20a86b6$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9c6b1212f20a86b6$var$ka = /[\-:]([a-z])/g;
function $9c6b1212f20a86b6$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9c6b1212f20a86b6$var$ka, $9c6b1212f20a86b6$var$la);
    $9c6b1212f20a86b6$var$t[b] = new $9c6b1212f20a86b6$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9c6b1212f20a86b6$var$t.xlinkHref = new $9c6b1212f20a86b6$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9c6b1212f20a86b6$var$t[a] = new $9c6b1212f20a86b6$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $9c6b1212f20a86b6$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9c6b1212f20a86b6$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9c6b1212f20a86b6$var$u).forEach(function(a) {
    $9c6b1212f20a86b6$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9c6b1212f20a86b6$var$u[b] = $9c6b1212f20a86b6$var$u[a];
    });
});
var $9c6b1212f20a86b6$var$na = /["'&<>]/;
function $9c6b1212f20a86b6$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $9c6b1212f20a86b6$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $9c6b1212f20a86b6$var$oa = /([A-Z])/g, $9c6b1212f20a86b6$var$pa = /^ms-/, $9c6b1212f20a86b6$var$qa = Array.isArray;
function $9c6b1212f20a86b6$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $9c6b1212f20a86b6$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $9c6b1212f20a86b6$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $9c6b1212f20a86b6$var$w(2, null);
        case "math":
            return $9c6b1212f20a86b6$var$w(3, null);
        case "foreignObject":
            return $9c6b1212f20a86b6$var$w(1, null);
        case "table":
            return $9c6b1212f20a86b6$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $9c6b1212f20a86b6$var$w(5, null);
        case "colgroup":
            return $9c6b1212f20a86b6$var$w(7, null);
        case "tr":
            return $9c6b1212f20a86b6$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $9c6b1212f20a86b6$var$w(1, null) : a;
}
var $9c6b1212f20a86b6$var$sa = new Map;
function $9c6b1212f20a86b6$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($9c6b1212f20a86b6$var$l(62));
    b = !0;
    for(var d in c)if ($9c6b1212f20a86b6$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $9c6b1212f20a86b6$var$v(d);
                f = $9c6b1212f20a86b6$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $9c6b1212f20a86b6$var$sa.get(e);
                void 0 !== g ? e = g : (g = $9c6b1212f20a86b6$var$v(e.replace($9c6b1212f20a86b6$var$oa, "-$1").toLowerCase().replace($9c6b1212f20a86b6$var$pa, "-ms-")), $9c6b1212f20a86b6$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $9c6b1212f20a86b6$var$p.call($9c6b1212f20a86b6$var$u, d) ? "" + f : f + "px" : $9c6b1212f20a86b6$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $9c6b1212f20a86b6$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $9c6b1212f20a86b6$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $9c6b1212f20a86b6$var$t.hasOwnProperty(c) ? $9c6b1212f20a86b6$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
            }
        } else if ($9c6b1212f20a86b6$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $9c6b1212f20a86b6$var$v(d), '"');
        }
    }
}
function $9c6b1212f20a86b6$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($9c6b1212f20a86b6$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($9c6b1212f20a86b6$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $9c6b1212f20a86b6$var$ua(a) {
    var b = "";
    $eJOHy.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $9c6b1212f20a86b6$var$va(a, b, c, d) {
    a.push($9c6b1212f20a86b6$var$A(c));
    var f = c = null, e;
    for(e in b)if ($9c6b1212f20a86b6$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $9c6b1212f20a86b6$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $9c6b1212f20a86b6$var$y(a, f, c);
    return "string" === typeof c ? (a.push($9c6b1212f20a86b6$var$v(c)), null) : c;
}
var $9c6b1212f20a86b6$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $9c6b1212f20a86b6$var$xa = new Map;
function $9c6b1212f20a86b6$var$A(a) {
    var b = $9c6b1212f20a86b6$var$xa.get(a);
    if (void 0 === b) {
        if (!$9c6b1212f20a86b6$var$wa.test(a)) throw Error($9c6b1212f20a86b6$var$l(65, a));
        b = "<" + a;
        $9c6b1212f20a86b6$var$xa.set(a, b);
    }
    return b;
}
function $9c6b1212f20a86b6$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($9c6b1212f20a86b6$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($9c6b1212f20a86b6$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $9c6b1212f20a86b6$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($9c6b1212f20a86b6$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($9c6b1212f20a86b6$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $9c6b1212f20a86b6$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $9c6b1212f20a86b6$var$ua(h), $9c6b1212f20a86b6$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($9c6b1212f20a86b6$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($9c6b1212f20a86b6$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(91));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($9c6b1212f20a86b6$var$l(92));
                if ($9c6b1212f20a86b6$var$qa(n) && 1 < n.length) throw Error($9c6b1212f20a86b6$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($9c6b1212f20a86b6$var$v("" + e));
            return null;
        case "input":
            a.push($9c6b1212f20a86b6$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($9c6b1212f20a86b6$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $9c6b1212f20a86b6$var$x(a, d, g, m);
            }
            null !== n ? $9c6b1212f20a86b6$var$x(a, d, "checked", n) : null !== k && $9c6b1212f20a86b6$var$x(a, d, "checked", k);
            null !== e ? $9c6b1212f20a86b6$var$x(a, d, "value", e) : null !== h && $9c6b1212f20a86b6$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($9c6b1212f20a86b6$var$A("menuitem"));
            for(var C in c)if ($9c6b1212f20a86b6$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(400));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($9c6b1212f20a86b6$var$A("title"));
            e = null;
            for(q in c)if ($9c6b1212f20a86b6$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(434));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($9c6b1212f20a86b6$var$A(b));
            g = e = null;
            for(k in c)if ($9c6b1212f20a86b6$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $9c6b1212f20a86b6$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($9c6b1212f20a86b6$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($9c6b1212f20a86b6$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($9c6b1212f20a86b6$var$A(b));
            for(var D in c)if ($9c6b1212f20a86b6$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9c6b1212f20a86b6$var$l(399, b));
                default:
                    $9c6b1212f20a86b6$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $9c6b1212f20a86b6$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $9c6b1212f20a86b6$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $9c6b1212f20a86b6$var$va(a, c, b, d);
            a.push($9c6b1212f20a86b6$var$A(b));
            g = e = null;
            for(m in c)if ($9c6b1212f20a86b6$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $9c6b1212f20a86b6$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $9c6b1212f20a86b6$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $9c6b1212f20a86b6$var$v(h), '"');
            }
            a.push(">");
            $9c6b1212f20a86b6$var$y(a, g, e);
            return e;
    }
}
function $9c6b1212f20a86b6$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($9c6b1212f20a86b6$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $9c6b1212f20a86b6$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($9c6b1212f20a86b6$var$l(397));
    }
}
function $9c6b1212f20a86b6$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($9c6b1212f20a86b6$var$l(397));
    }
}
var $9c6b1212f20a86b6$var$Ca = /[<\u2028\u2029]/g;
function $9c6b1212f20a86b6$var$Da(a) {
    return JSON.stringify(a).replace($9c6b1212f20a86b6$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $9c6b1212f20a86b6$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $9c6b1212f20a86b6$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($9c6b1212f20a86b6$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($9c6b1212f20a86b6$var$v(b)), a = !0);
    return a;
}
var $9c6b1212f20a86b6$var$B = Object.assign, $9c6b1212f20a86b6$var$Ga = Symbol.for("react.element"), $9c6b1212f20a86b6$var$Ha = Symbol.for("react.portal"), $9c6b1212f20a86b6$var$Ia = Symbol.for("react.fragment"), $9c6b1212f20a86b6$var$Ja = Symbol.for("react.strict_mode"), $9c6b1212f20a86b6$var$Ka = Symbol.for("react.profiler"), $9c6b1212f20a86b6$var$La = Symbol.for("react.provider"), $9c6b1212f20a86b6$var$Ma = Symbol.for("react.context"), $9c6b1212f20a86b6$var$Na = Symbol.for("react.forward_ref"), $9c6b1212f20a86b6$var$Oa = Symbol.for("react.suspense"), $9c6b1212f20a86b6$var$Pa = Symbol.for("react.suspense_list"), $9c6b1212f20a86b6$var$Qa = Symbol.for("react.memo"), $9c6b1212f20a86b6$var$Ra = Symbol.for("react.lazy"), $9c6b1212f20a86b6$var$Sa = Symbol.for("react.scope"), $9c6b1212f20a86b6$var$Ta = Symbol.for("react.debug_trace_mode"), $9c6b1212f20a86b6$var$Ua = Symbol.for("react.legacy_hidden"), $9c6b1212f20a86b6$var$Va = Symbol.for("react.default_value"), $9c6b1212f20a86b6$var$Wa = Symbol.iterator;
function $9c6b1212f20a86b6$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9c6b1212f20a86b6$var$Ia:
            return "Fragment";
        case $9c6b1212f20a86b6$var$Ha:
            return "Portal";
        case $9c6b1212f20a86b6$var$Ka:
            return "Profiler";
        case $9c6b1212f20a86b6$var$Ja:
            return "StrictMode";
        case $9c6b1212f20a86b6$var$Oa:
            return "Suspense";
        case $9c6b1212f20a86b6$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9c6b1212f20a86b6$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $9c6b1212f20a86b6$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $9c6b1212f20a86b6$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9c6b1212f20a86b6$var$Qa:
            return b = a.displayName || null, null !== b ? b : $9c6b1212f20a86b6$var$Xa(a.type) || "Memo";
        case $9c6b1212f20a86b6$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $9c6b1212f20a86b6$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $9c6b1212f20a86b6$var$Ya = {};
function $9c6b1212f20a86b6$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $9c6b1212f20a86b6$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $9c6b1212f20a86b6$var$E = null;
function $9c6b1212f20a86b6$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($9c6b1212f20a86b6$var$l(401));
        } else {
            if (null === c) throw Error($9c6b1212f20a86b6$var$l(401));
            $9c6b1212f20a86b6$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $9c6b1212f20a86b6$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $9c6b1212f20a86b6$var$$a(a);
}
function $9c6b1212f20a86b6$var$ab(a) {
    var b = a.parent;
    null !== b && $9c6b1212f20a86b6$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $9c6b1212f20a86b6$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($9c6b1212f20a86b6$var$l(402));
    a.depth === b.depth ? $9c6b1212f20a86b6$var$F(a, b) : $9c6b1212f20a86b6$var$bb(a, b);
}
function $9c6b1212f20a86b6$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($9c6b1212f20a86b6$var$l(402));
    a.depth === c.depth ? $9c6b1212f20a86b6$var$F(a, c) : $9c6b1212f20a86b6$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $9c6b1212f20a86b6$var$G(a) {
    var b = $9c6b1212f20a86b6$var$E;
    b !== a && (null === b ? $9c6b1212f20a86b6$var$ab(a) : null === a ? $9c6b1212f20a86b6$var$$a(b) : b.depth === a.depth ? $9c6b1212f20a86b6$var$F(b, a) : b.depth > a.depth ? $9c6b1212f20a86b6$var$bb(b, a) : $9c6b1212f20a86b6$var$cb(b, a), $9c6b1212f20a86b6$var$E = a);
}
var $9c6b1212f20a86b6$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $9c6b1212f20a86b6$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $9c6b1212f20a86b6$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $9c6b1212f20a86b6$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $9c6b1212f20a86b6$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $9c6b1212f20a86b6$var$B({}, e, h)) : $9c6b1212f20a86b6$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $9c6b1212f20a86b6$var$fb = {
    id: 1,
    overflow: ""
};
function $9c6b1212f20a86b6$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $9c6b1212f20a86b6$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $9c6b1212f20a86b6$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $9c6b1212f20a86b6$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $9c6b1212f20a86b6$var$H = Math.clz32 ? Math.clz32 : $9c6b1212f20a86b6$var$hb, $9c6b1212f20a86b6$var$ib = Math.log, $9c6b1212f20a86b6$var$jb = Math.LN2;
function $9c6b1212f20a86b6$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9c6b1212f20a86b6$var$ib(a) / $9c6b1212f20a86b6$var$jb | 0) | 0;
}
function $9c6b1212f20a86b6$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9c6b1212f20a86b6$var$lb = "function" === typeof Object.is ? Object.is : $9c6b1212f20a86b6$var$kb, $9c6b1212f20a86b6$var$I = null, $9c6b1212f20a86b6$var$ob = null, $9c6b1212f20a86b6$var$J = null, $9c6b1212f20a86b6$var$K = null, $9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$M = !1, $9c6b1212f20a86b6$var$N = 0, $9c6b1212f20a86b6$var$O = null, $9c6b1212f20a86b6$var$P = 0;
function $9c6b1212f20a86b6$var$Q() {
    if (null === $9c6b1212f20a86b6$var$I) throw Error($9c6b1212f20a86b6$var$l(321));
    return $9c6b1212f20a86b6$var$I;
}
function $9c6b1212f20a86b6$var$pb() {
    if (0 < $9c6b1212f20a86b6$var$P) throw Error($9c6b1212f20a86b6$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $9c6b1212f20a86b6$var$qb() {
    null === $9c6b1212f20a86b6$var$K ? null === $9c6b1212f20a86b6$var$J ? ($9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$J = $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$pb()) : ($9c6b1212f20a86b6$var$L = !0, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$J) : null === $9c6b1212f20a86b6$var$K.next ? ($9c6b1212f20a86b6$var$L = !1, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$K.next = $9c6b1212f20a86b6$var$pb()) : ($9c6b1212f20a86b6$var$L = !0, $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$K.next);
    return $9c6b1212f20a86b6$var$K;
}
function $9c6b1212f20a86b6$var$rb() {
    $9c6b1212f20a86b6$var$ob = $9c6b1212f20a86b6$var$I = null;
    $9c6b1212f20a86b6$var$M = !1;
    $9c6b1212f20a86b6$var$J = null;
    $9c6b1212f20a86b6$var$P = 0;
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$O = null;
}
function $9c6b1212f20a86b6$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9c6b1212f20a86b6$var$tb(a, b, c) {
    $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
    if ($9c6b1212f20a86b6$var$L) {
        var d = $9c6b1212f20a86b6$var$K.queue;
        b = d.dispatch;
        if (null !== $9c6b1212f20a86b6$var$O && (c = $9c6b1212f20a86b6$var$O.get(d), void 0 !== c)) {
            $9c6b1212f20a86b6$var$O.delete(d);
            d = $9c6b1212f20a86b6$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $9c6b1212f20a86b6$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $9c6b1212f20a86b6$var$K.memoizedState,
            b
        ];
    }
    a = a === $9c6b1212f20a86b6$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $9c6b1212f20a86b6$var$K.memoizedState = a;
    a = $9c6b1212f20a86b6$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $9c6b1212f20a86b6$var$ub.bind(null, $9c6b1212f20a86b6$var$I, a);
    return [
        $9c6b1212f20a86b6$var$K.memoizedState,
        a
    ];
}
function $9c6b1212f20a86b6$var$vb(a, b) {
    $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
    $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $9c6b1212f20a86b6$var$K) {
        var c = $9c6b1212f20a86b6$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$9c6b1212f20a86b6$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $9c6b1212f20a86b6$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c6b1212f20a86b6$var$ub(a, b, c) {
    if (25 <= $9c6b1212f20a86b6$var$P) throw Error($9c6b1212f20a86b6$var$l(301));
    if (a === $9c6b1212f20a86b6$var$I) {
        if ($9c6b1212f20a86b6$var$M = !0, a = {
            action: c,
            next: null
        }, null === $9c6b1212f20a86b6$var$O && ($9c6b1212f20a86b6$var$O = new Map), c = $9c6b1212f20a86b6$var$O.get(b), void 0 === c) $9c6b1212f20a86b6$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $9c6b1212f20a86b6$var$wb() {
    throw Error($9c6b1212f20a86b6$var$l(394));
}
function $9c6b1212f20a86b6$var$R() {}
var $9c6b1212f20a86b6$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $9c6b1212f20a86b6$var$Q();
        return a._currentValue2;
    },
    useMemo: $9c6b1212f20a86b6$var$vb,
    useReducer: $9c6b1212f20a86b6$var$tb,
    useRef: function(a) {
        $9c6b1212f20a86b6$var$I = $9c6b1212f20a86b6$var$Q();
        $9c6b1212f20a86b6$var$K = $9c6b1212f20a86b6$var$qb();
        var b = $9c6b1212f20a86b6$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $9c6b1212f20a86b6$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $9c6b1212f20a86b6$var$tb($9c6b1212f20a86b6$var$sb, a);
    },
    useInsertionEffect: $9c6b1212f20a86b6$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $9c6b1212f20a86b6$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $9c6b1212f20a86b6$var$R,
    useEffect: $9c6b1212f20a86b6$var$R,
    useDebugValue: $9c6b1212f20a86b6$var$R,
    useDeferredValue: function(a) {
        $9c6b1212f20a86b6$var$Q();
        return a;
    },
    useTransition: function() {
        $9c6b1212f20a86b6$var$Q();
        return [
            !1,
            $9c6b1212f20a86b6$var$wb
        ];
    },
    useId: function() {
        var a = $9c6b1212f20a86b6$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $9c6b1212f20a86b6$var$H(a) - 1)).toString(32) + b;
        var c = $9c6b1212f20a86b6$var$S;
        if (null === c) throw Error($9c6b1212f20a86b6$var$l(404));
        b = $9c6b1212f20a86b6$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $9c6b1212f20a86b6$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($9c6b1212f20a86b6$var$l(407));
        return c();
    }
}, $9c6b1212f20a86b6$var$S = null, $9c6b1212f20a86b6$var$yb = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $9c6b1212f20a86b6$var$zb(a) {
    console.error(a);
    return null;
}
function $9c6b1212f20a86b6$var$T() {}
function $9c6b1212f20a86b6$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $9c6b1212f20a86b6$var$zb : f,
        onAllReady: void 0 === e ? $9c6b1212f20a86b6$var$T : e,
        onShellReady: void 0 === g ? $9c6b1212f20a86b6$var$T : g,
        onShellError: void 0 === h ? $9c6b1212f20a86b6$var$T : h,
        onFatalError: void 0 === k ? $9c6b1212f20a86b6$var$T : k
    };
    c = $9c6b1212f20a86b6$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $9c6b1212f20a86b6$var$Bb(b, a, null, c, n, $9c6b1212f20a86b6$var$Ya, null, $9c6b1212f20a86b6$var$fb);
    m.push(a);
    return b;
}
function $9c6b1212f20a86b6$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $9c6b1212f20a86b6$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $9c6b1212f20a86b6$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $9c6b1212f20a86b6$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $9c6b1212f20a86b6$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $9c6b1212f20a86b6$var$Db(a, b, c, d, f) {
    $9c6b1212f20a86b6$var$I = {};
    $9c6b1212f20a86b6$var$ob = b;
    $9c6b1212f20a86b6$var$N = 0;
    for(a = c(d, f); $9c6b1212f20a86b6$var$M;)$9c6b1212f20a86b6$var$M = !1, $9c6b1212f20a86b6$var$N = 0, $9c6b1212f20a86b6$var$P += 1, $9c6b1212f20a86b6$var$K = null, a = c(d, f);
    $9c6b1212f20a86b6$var$rb();
    return a;
}
function $9c6b1212f20a86b6$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($9c6b1212f20a86b6$var$l(108, $9c6b1212f20a86b6$var$Xa(d) || "Unknown", h));
            d = $9c6b1212f20a86b6$var$B({}, g, c);
        }
        b.legacyContext = d;
        $9c6b1212f20a86b6$var$X(a, b, f);
        b.legacyContext = g;
    } else $9c6b1212f20a86b6$var$X(a, b, f);
}
function $9c6b1212f20a86b6$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $9c6b1212f20a86b6$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9c6b1212f20a86b6$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $9c6b1212f20a86b6$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $9c6b1212f20a86b6$var$eb(e, c, d, f);
            $9c6b1212f20a86b6$var$Eb(a, b, e, c);
        } else {
            e = $9c6b1212f20a86b6$var$Za(c, b.legacyContext);
            f = $9c6b1212f20a86b6$var$Db(a, b, c, d, e);
            var g = 0 !== $9c6b1212f20a86b6$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $9c6b1212f20a86b6$var$eb(f, c, d, e), $9c6b1212f20a86b6$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $9c6b1212f20a86b6$var$gb(d, 1, 0);
                try {
                    $9c6b1212f20a86b6$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $9c6b1212f20a86b6$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $9c6b1212f20a86b6$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $9c6b1212f20a86b6$var$ra(g, c, d);
        $9c6b1212f20a86b6$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $9c6b1212f20a86b6$var$Ua:
            case $9c6b1212f20a86b6$var$Ta:
            case $9c6b1212f20a86b6$var$Ja:
            case $9c6b1212f20a86b6$var$Ka:
            case $9c6b1212f20a86b6$var$Ia:
                $9c6b1212f20a86b6$var$X(a, b, d.children);
                return;
            case $9c6b1212f20a86b6$var$Pa:
                $9c6b1212f20a86b6$var$X(a, b, d.children);
                return;
            case $9c6b1212f20a86b6$var$Sa:
                throw Error($9c6b1212f20a86b6$var$l(343));
            case $9c6b1212f20a86b6$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $9c6b1212f20a86b6$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $9c6b1212f20a86b6$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($9c6b1212f20a86b6$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $9c6b1212f20a86b6$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $9c6b1212f20a86b6$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $9c6b1212f20a86b6$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $9c6b1212f20a86b6$var$Na:
                d = $9c6b1212f20a86b6$var$Db(a, b, c.render, d, f);
                if (0 !== $9c6b1212f20a86b6$var$N) {
                    c = b.treeContext;
                    b.treeContext = $9c6b1212f20a86b6$var$gb(c, 1, 0);
                    try {
                        $9c6b1212f20a86b6$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $9c6b1212f20a86b6$var$X(a, b, d);
                return;
            case $9c6b1212f20a86b6$var$Qa:
                c = c.type;
                d = $9c6b1212f20a86b6$var$Fb(c, d);
                $9c6b1212f20a86b6$var$Gb(a, b, c, d, f);
                return;
            case $9c6b1212f20a86b6$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $9c6b1212f20a86b6$var$E;
                $9c6b1212f20a86b6$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $9c6b1212f20a86b6$var$X(a, b, f);
                a = $9c6b1212f20a86b6$var$E;
                if (null === a) throw Error($9c6b1212f20a86b6$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $9c6b1212f20a86b6$var$Va ? a.context._defaultValue : d;
                a = $9c6b1212f20a86b6$var$E = a.parent;
                b.context = a;
                return;
            case $9c6b1212f20a86b6$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $9c6b1212f20a86b6$var$X(a, b, d);
                return;
            case $9c6b1212f20a86b6$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $9c6b1212f20a86b6$var$Fb(c, d);
                $9c6b1212f20a86b6$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($9c6b1212f20a86b6$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $9c6b1212f20a86b6$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $9c6b1212f20a86b6$var$Ga:
                $9c6b1212f20a86b6$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $9c6b1212f20a86b6$var$Ha:
                throw Error($9c6b1212f20a86b6$var$l(257));
            case $9c6b1212f20a86b6$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $9c6b1212f20a86b6$var$X(a, b, c);
                return;
        }
        if ($9c6b1212f20a86b6$var$qa(c)) {
            $9c6b1212f20a86b6$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $9c6b1212f20a86b6$var$Wa && c[$9c6b1212f20a86b6$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $9c6b1212f20a86b6$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($9c6b1212f20a86b6$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $9c6b1212f20a86b6$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $9c6b1212f20a86b6$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $9c6b1212f20a86b6$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $9c6b1212f20a86b6$var$gb(e, d, f);
        try {
            $9c6b1212f20a86b6$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $9c6b1212f20a86b6$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $9c6b1212f20a86b6$var$X(a, b, c);
    } catch (k) {
        if ($9c6b1212f20a86b6$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $9c6b1212f20a86b6$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $9c6b1212f20a86b6$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $9c6b1212f20a86b6$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $9c6b1212f20a86b6$var$G(e), k;
    }
}
function $9c6b1212f20a86b6$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $9c6b1212f20a86b6$var$Kb(this, b, a);
}
function $9c6b1212f20a86b6$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($9c6b1212f20a86b6$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $9c6b1212f20a86b6$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $9c6b1212f20a86b6$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $9c6b1212f20a86b6$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $9c6b1212f20a86b6$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($9c6b1212f20a86b6$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $9c6b1212f20a86b6$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $9c6b1212f20a86b6$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($9c6b1212f20a86b6$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($9c6b1212f20a86b6$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $9c6b1212f20a86b6$var$Cb(a) {
    if (2 !== a.status) {
        var b = $9c6b1212f20a86b6$var$E, c = $9c6b1212f20a86b6$var$yb.current;
        $9c6b1212f20a86b6$var$yb.current = $9c6b1212f20a86b6$var$xb;
        var d = $9c6b1212f20a86b6$var$S;
        $9c6b1212f20a86b6$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $9c6b1212f20a86b6$var$G(g.context);
                    try {
                        $9c6b1212f20a86b6$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $9c6b1212f20a86b6$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($9c6b1212f20a86b6$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $9c6b1212f20a86b6$var$V(h, q);
                            null === n ? $9c6b1212f20a86b6$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $9c6b1212f20a86b6$var$Mb(a, a.destination);
        } catch (z) {
            $9c6b1212f20a86b6$var$V(a, z), $9c6b1212f20a86b6$var$W(a, z);
        } finally{
            $9c6b1212f20a86b6$var$S = d, $9c6b1212f20a86b6$var$yb.current = c, c === $9c6b1212f20a86b6$var$xb && $9c6b1212f20a86b6$var$G(b);
        }
    }
}
function $9c6b1212f20a86b6$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $9c6b1212f20a86b6$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($9c6b1212f20a86b6$var$l(390));
    }
}
function $9c6b1212f20a86b6$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $9c6b1212f20a86b6$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $9c6b1212f20a86b6$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $9c6b1212f20a86b6$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $9c6b1212f20a86b6$var$za(b, a.responseState, d);
        $9c6b1212f20a86b6$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $9c6b1212f20a86b6$var$za(b, a.responseState, d.id), $9c6b1212f20a86b6$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($9c6b1212f20a86b6$var$l(391));
    $9c6b1212f20a86b6$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $9c6b1212f20a86b6$var$Ob(a, b, c) {
    $9c6b1212f20a86b6$var$Aa(b, a.responseState, c.formatContext, c.id);
    $9c6b1212f20a86b6$var$Nb(a, b, c);
    return $9c6b1212f20a86b6$var$Ba(b, c.formatContext);
}
function $9c6b1212f20a86b6$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$9c6b1212f20a86b6$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($9c6b1212f20a86b6$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $9c6b1212f20a86b6$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($9c6b1212f20a86b6$var$l(392));
        return $9c6b1212f20a86b6$var$Ob(a, b, d);
    }
    $9c6b1212f20a86b6$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $9c6b1212f20a86b6$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $9c6b1212f20a86b6$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($9c6b1212f20a86b6$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $9c6b1212f20a86b6$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $9c6b1212f20a86b6$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $9c6b1212f20a86b6$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$9c6b1212f20a86b6$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$9c6b1212f20a86b6$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$9c6b1212f20a86b6$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $9c6b1212f20a86b6$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $9c6b1212f20a86b6$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $9c6b1212f20a86b6$var$Mb(a, a.destination);
    } catch (d) {
        $9c6b1212f20a86b6$var$V(a, d), $9c6b1212f20a86b6$var$W(a, d);
    }
}
function $9c6b1212f20a86b6$var$Sb() {}
function $9c6b1212f20a86b6$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $9c6b1212f20a86b6$var$Ab(a, $9c6b1212f20a86b6$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, b && b.onError ? b.onError : $9c6b1212f20a86b6$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $9c6b1212f20a86b6$var$Cb(a);
    $9c6b1212f20a86b6$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $9c6b1212f20a86b6$var$Mb(a, h);
        } catch (m) {
            $9c6b1212f20a86b6$var$V(a, m), $9c6b1212f20a86b6$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($9c6b1212f20a86b6$var$l(426));
    return g;
}
$9c6b1212f20a86b6$export$307591e98609eddd = function() {
    throw Error($9c6b1212f20a86b6$var$l(207));
};
$9c6b1212f20a86b6$export$eb3a06aef9e6ee51 = function(a, b) {
    return $9c6b1212f20a86b6$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9c6b1212f20a86b6$export$b23711c915539651 = function() {
    throw Error($9c6b1212f20a86b6$var$l(208));
};
$9c6b1212f20a86b6$export$80e7718417253a51 = function(a, b) {
    return $9c6b1212f20a86b6$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9c6b1212f20a86b6$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("tjq0h", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $0581c5a3dec30813$export$7020a3240b287705, (v) => $0581c5a3dec30813$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $0581c5a3dec30813$export$83d89fbfd8236492, (v) => $0581c5a3dec30813$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0581c5a3dec30813$export$7020a3240b287705;
var $0581c5a3dec30813$export$83d89fbfd8236492;
'use strict';

var $eJOHy = parcelRequire("eJOHy");
function $0581c5a3dec30813$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0581c5a3dec30813$var$l = null, $0581c5a3dec30813$var$n = 0;
function $0581c5a3dec30813$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $0581c5a3dec30813$var$n && (a.enqueue(new Uint8Array($0581c5a3dec30813$var$l.buffer, 0, $0581c5a3dec30813$var$n)), $0581c5a3dec30813$var$l = new Uint8Array(512), $0581c5a3dec30813$var$n = 0), a.enqueue(b);
        else {
            var c = $0581c5a3dec30813$var$l.length - $0581c5a3dec30813$var$n;
            c < b.length && (0 === c ? a.enqueue($0581c5a3dec30813$var$l) : ($0581c5a3dec30813$var$l.set(b.subarray(0, c), $0581c5a3dec30813$var$n), a.enqueue($0581c5a3dec30813$var$l), b = b.subarray(c)), $0581c5a3dec30813$var$l = new Uint8Array(512), $0581c5a3dec30813$var$n = 0);
            $0581c5a3dec30813$var$l.set(b, $0581c5a3dec30813$var$n);
            $0581c5a3dec30813$var$n += b.length;
        }
    }
}
function $0581c5a3dec30813$var$t(a, b) {
    $0581c5a3dec30813$var$p(a, b);
    return !0;
}
function $0581c5a3dec30813$var$ba(a) {
    $0581c5a3dec30813$var$l && 0 < $0581c5a3dec30813$var$n && (a.enqueue(new Uint8Array($0581c5a3dec30813$var$l.buffer, 0, $0581c5a3dec30813$var$n)), $0581c5a3dec30813$var$l = null, $0581c5a3dec30813$var$n = 0);
}
var $0581c5a3dec30813$var$ca = new TextEncoder;
function $0581c5a3dec30813$var$u(a) {
    return $0581c5a3dec30813$var$ca.encode(a);
}
function $0581c5a3dec30813$var$w(a) {
    return $0581c5a3dec30813$var$ca.encode(a);
}
function $0581c5a3dec30813$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $0581c5a3dec30813$var$x = Object.prototype.hasOwnProperty, $0581c5a3dec30813$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0581c5a3dec30813$var$fa = {}, $0581c5a3dec30813$var$ha = {};
function $0581c5a3dec30813$var$ia(a) {
    if ($0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$ha, a)) return !0;
    if ($0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$fa, a)) return !1;
    if ($0581c5a3dec30813$var$ea.test(a)) return $0581c5a3dec30813$var$ha[a] = !0;
    $0581c5a3dec30813$var$fa[a] = !0;
    return !1;
}
function $0581c5a3dec30813$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $0581c5a3dec30813$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0581c5a3dec30813$var$ja = /[\-:]([a-z])/g;
function $0581c5a3dec30813$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0581c5a3dec30813$var$ja, $0581c5a3dec30813$var$ka);
    $0581c5a3dec30813$var$z[b] = new $0581c5a3dec30813$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0581c5a3dec30813$var$z.xlinkHref = new $0581c5a3dec30813$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0581c5a3dec30813$var$z[a] = new $0581c5a3dec30813$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $0581c5a3dec30813$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0581c5a3dec30813$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0581c5a3dec30813$var$B).forEach(function(a) {
    $0581c5a3dec30813$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0581c5a3dec30813$var$B[b] = $0581c5a3dec30813$var$B[a];
    });
});
var $0581c5a3dec30813$var$oa = /["'&<>]/;
function $0581c5a3dec30813$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $0581c5a3dec30813$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $0581c5a3dec30813$var$pa = /([A-Z])/g, $0581c5a3dec30813$var$qa = /^ms-/, $0581c5a3dec30813$var$ra = Array.isArray, $0581c5a3dec30813$var$sa = $0581c5a3dec30813$var$w("<script>"), $0581c5a3dec30813$var$ta = $0581c5a3dec30813$var$w("\x3c/script>"), $0581c5a3dec30813$var$ua = $0581c5a3dec30813$var$w('<script src="'), $0581c5a3dec30813$var$va = $0581c5a3dec30813$var$w('<script type="module" src="'), $0581c5a3dec30813$var$wa = $0581c5a3dec30813$var$w('" async="">\x3c/script>'), $0581c5a3dec30813$var$xa = /(<\/|<)(s)(cript)/gi;
function $0581c5a3dec30813$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $0581c5a3dec30813$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $0581c5a3dec30813$var$sa : $0581c5a3dec30813$var$w('<script nonce="' + $0581c5a3dec30813$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $0581c5a3dec30813$var$u(("" + c).replace($0581c5a3dec30813$var$xa, $0581c5a3dec30813$var$ya)), $0581c5a3dec30813$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($0581c5a3dec30813$var$ua, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d[c])), $0581c5a3dec30813$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($0581c5a3dec30813$var$va, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(f[d])), $0581c5a3dec30813$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $0581c5a3dec30813$var$w(a + "P:"),
        segmentPrefix: $0581c5a3dec30813$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $0581c5a3dec30813$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $0581c5a3dec30813$var$Aa(a) {
    return $0581c5a3dec30813$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $0581c5a3dec30813$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $0581c5a3dec30813$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $0581c5a3dec30813$var$D(2, null);
        case "math":
            return $0581c5a3dec30813$var$D(3, null);
        case "foreignObject":
            return $0581c5a3dec30813$var$D(1, null);
        case "table":
            return $0581c5a3dec30813$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $0581c5a3dec30813$var$D(5, null);
        case "colgroup":
            return $0581c5a3dec30813$var$D(7, null);
        case "tr":
            return $0581c5a3dec30813$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $0581c5a3dec30813$var$D(1, null) : a;
}
var $0581c5a3dec30813$var$Ca = $0581c5a3dec30813$var$w("\x3c!-- --\x3e");
function $0581c5a3dec30813$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($0581c5a3dec30813$var$Ca);
    a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(b)));
    return !0;
}
var $0581c5a3dec30813$var$Ea = new Map, $0581c5a3dec30813$var$Fa = $0581c5a3dec30813$var$w(' style="'), $0581c5a3dec30813$var$Ga = $0581c5a3dec30813$var$w(":"), $0581c5a3dec30813$var$Ha = $0581c5a3dec30813$var$w(";");
function $0581c5a3dec30813$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($0581c5a3dec30813$var$k(62));
    b = !0;
    for(var d in c)if ($0581c5a3dec30813$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d));
                f = $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $0581c5a3dec30813$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $0581c5a3dec30813$var$w($0581c5a3dec30813$var$C(e.replace($0581c5a3dec30813$var$pa, "-$1").toLowerCase().replace($0581c5a3dec30813$var$qa, "-ms-"))), $0581c5a3dec30813$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $0581c5a3dec30813$var$x.call($0581c5a3dec30813$var$B, d) ? $0581c5a3dec30813$var$u("" + f) : $0581c5a3dec30813$var$u(f + "px") : $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($0581c5a3dec30813$var$Fa, e, $0581c5a3dec30813$var$Ga, f)) : a.push($0581c5a3dec30813$var$Ha, e, $0581c5a3dec30813$var$Ga, f);
        }
    }
    b || a.push($0581c5a3dec30813$var$E);
}
var $0581c5a3dec30813$var$H = $0581c5a3dec30813$var$w(" "), $0581c5a3dec30813$var$I = $0581c5a3dec30813$var$w('="'), $0581c5a3dec30813$var$E = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$Ja = $0581c5a3dec30813$var$w('=""');
function $0581c5a3dec30813$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $0581c5a3dec30813$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $0581c5a3dec30813$var$z.hasOwnProperty(c) ? $0581c5a3dec30813$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $0581c5a3dec30813$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$Ja) : !1 !== d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($0581c5a3dec30813$var$H, c, $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
            }
        } else if ($0581c5a3dec30813$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($0581c5a3dec30813$var$H, $0581c5a3dec30813$var$u(c), $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d)), $0581c5a3dec30813$var$E);
        }
    }
}
var $0581c5a3dec30813$var$K = $0581c5a3dec30813$var$w(">"), $0581c5a3dec30813$var$Ka = $0581c5a3dec30813$var$w("/>");
function $0581c5a3dec30813$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($0581c5a3dec30813$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($0581c5a3dec30813$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($0581c5a3dec30813$var$u("" + b));
    }
}
function $0581c5a3dec30813$var$La(a) {
    var b = "";
    $eJOHy.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $0581c5a3dec30813$var$Ma = $0581c5a3dec30813$var$w(' selected=""');
function $0581c5a3dec30813$var$Na(a, b, c, d) {
    a.push($0581c5a3dec30813$var$M(c));
    var f = c = null, e;
    for(e in b)if ($0581c5a3dec30813$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $0581c5a3dec30813$var$J(a, d, e, g);
        }
    }
    a.push($0581c5a3dec30813$var$K);
    $0581c5a3dec30813$var$L(a, f, c);
    return "string" === typeof c ? (a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(c))), null) : c;
}
var $0581c5a3dec30813$var$Oa = $0581c5a3dec30813$var$w("\n"), $0581c5a3dec30813$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $0581c5a3dec30813$var$Qa = new Map;
function $0581c5a3dec30813$var$M(a) {
    var b = $0581c5a3dec30813$var$Qa.get(a);
    if (void 0 === b) {
        if (!$0581c5a3dec30813$var$Pa.test(a)) throw Error($0581c5a3dec30813$var$k(65, a));
        b = $0581c5a3dec30813$var$w("<" + a);
        $0581c5a3dec30813$var$Qa.set(a, b);
    }
    return b;
}
var $0581c5a3dec30813$var$Ra = $0581c5a3dec30813$var$w("<!DOCTYPE html>");
function $0581c5a3dec30813$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($0581c5a3dec30813$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($0581c5a3dec30813$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $0581c5a3dec30813$var$J(a, d, r, h);
                }
            }
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($0581c5a3dec30813$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($0581c5a3dec30813$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $0581c5a3dec30813$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $0581c5a3dec30813$var$La(h), $0581c5a3dec30813$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($0581c5a3dec30813$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($0581c5a3dec30813$var$Ma);
            } else q && a.push($0581c5a3dec30813$var$Ma);
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($0581c5a3dec30813$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($0581c5a3dec30813$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(91));
                default:
                    $0581c5a3dec30813$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($0581c5a3dec30813$var$K);
            if (null != r) {
                if (null != e) throw Error($0581c5a3dec30813$var$k(92));
                if ($0581c5a3dec30813$var$ra(r) && 1 < r.length) throw Error($0581c5a3dec30813$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($0581c5a3dec30813$var$Oa);
            null !== e && a.push($0581c5a3dec30813$var$u($0581c5a3dec30813$var$C("" + e)));
            return null;
        case "input":
            a.push($0581c5a3dec30813$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($0581c5a3dec30813$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $0581c5a3dec30813$var$J(a, d, g, q);
            }
            null !== r ? $0581c5a3dec30813$var$J(a, d, "checked", r) : null !== m && $0581c5a3dec30813$var$J(a, d, "checked", m);
            null !== e ? $0581c5a3dec30813$var$J(a, d, "value", e) : null !== h && $0581c5a3dec30813$var$J(a, d, "value", h);
            a.push($0581c5a3dec30813$var$Ka);
            return null;
        case "menuitem":
            a.push($0581c5a3dec30813$var$M("menuitem"));
            for(var A in c)if ($0581c5a3dec30813$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(400));
                default:
                    $0581c5a3dec30813$var$J(a, d, A, e);
            }
            a.push($0581c5a3dec30813$var$K);
            return null;
        case "title":
            a.push($0581c5a3dec30813$var$M("title"));
            e = null;
            for(v in c)if ($0581c5a3dec30813$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(434));
                default:
                    $0581c5a3dec30813$var$J(a, d, v, g);
            }
            a.push($0581c5a3dec30813$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($0581c5a3dec30813$var$M(b));
            g = e = null;
            for(m in c)if ($0581c5a3dec30813$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $0581c5a3dec30813$var$J(a, d, m, h);
            }
            a.push($0581c5a3dec30813$var$K);
            if (null != g) {
                if (null != e) throw Error($0581c5a3dec30813$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($0581c5a3dec30813$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($0581c5a3dec30813$var$Oa, $0581c5a3dec30813$var$u(c)) : a.push($0581c5a3dec30813$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($0581c5a3dec30813$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($0581c5a3dec30813$var$M(b));
            for(var F in c)if ($0581c5a3dec30813$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0581c5a3dec30813$var$k(399, b));
                default:
                    $0581c5a3dec30813$var$J(a, d, F, e);
            }
            a.push($0581c5a3dec30813$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $0581c5a3dec30813$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($0581c5a3dec30813$var$Ra), $0581c5a3dec30813$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $0581c5a3dec30813$var$Na(a, c, b, d);
            a.push($0581c5a3dec30813$var$M(b));
            g = e = null;
            for(q in c)if ($0581c5a3dec30813$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $0581c5a3dec30813$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $0581c5a3dec30813$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($0581c5a3dec30813$var$H, $0581c5a3dec30813$var$u(q), $0581c5a3dec30813$var$I, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(h)), $0581c5a3dec30813$var$E);
            }
            a.push($0581c5a3dec30813$var$K);
            $0581c5a3dec30813$var$L(a, g, e);
            return e;
    }
}
var $0581c5a3dec30813$var$Ta = $0581c5a3dec30813$var$w("</"), $0581c5a3dec30813$var$Ua = $0581c5a3dec30813$var$w(">"), $0581c5a3dec30813$var$Va = $0581c5a3dec30813$var$w('<template id="'), $0581c5a3dec30813$var$Wa = $0581c5a3dec30813$var$w('"></template>'), $0581c5a3dec30813$var$Xa = $0581c5a3dec30813$var$w("\x3c!--$--\x3e"), $0581c5a3dec30813$var$Ya = $0581c5a3dec30813$var$w('\x3c!--$?--\x3e<template id="'), $0581c5a3dec30813$var$Za = $0581c5a3dec30813$var$w('"></template>'), $0581c5a3dec30813$var$$a = $0581c5a3dec30813$var$w("\x3c!--$!--\x3e"), $0581c5a3dec30813$var$ab = $0581c5a3dec30813$var$w("\x3c!--/$--\x3e"), $0581c5a3dec30813$var$bb = $0581c5a3dec30813$var$w("<template"), $0581c5a3dec30813$var$cb = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$db = $0581c5a3dec30813$var$w(' data-dgst="');
$0581c5a3dec30813$var$w(' data-msg="');
$0581c5a3dec30813$var$w(' data-stck="');
var $0581c5a3dec30813$var$eb = $0581c5a3dec30813$var$w("></template>");
function $0581c5a3dec30813$var$fb(a, b, c) {
    $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$Ya);
    if (null === c) throw Error($0581c5a3dec30813$var$k(395));
    $0581c5a3dec30813$var$p(a, c);
    return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$Za);
}
var $0581c5a3dec30813$var$gb = $0581c5a3dec30813$var$w('<div hidden id="'), $0581c5a3dec30813$var$hb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ib = $0581c5a3dec30813$var$w("</div>"), $0581c5a3dec30813$var$jb = $0581c5a3dec30813$var$w('<svg aria-hidden="true" style="display:none" id="'), $0581c5a3dec30813$var$kb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$lb = $0581c5a3dec30813$var$w("</svg>"), $0581c5a3dec30813$var$mb = $0581c5a3dec30813$var$w('<math aria-hidden="true" style="display:none" id="'), $0581c5a3dec30813$var$nb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ob = $0581c5a3dec30813$var$w("</math>"), $0581c5a3dec30813$var$pb = $0581c5a3dec30813$var$w('<table hidden id="'), $0581c5a3dec30813$var$qb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$rb = $0581c5a3dec30813$var$w("</table>"), $0581c5a3dec30813$var$sb = $0581c5a3dec30813$var$w('<table hidden><tbody id="'), $0581c5a3dec30813$var$tb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$ub = $0581c5a3dec30813$var$w("</tbody></table>"), $0581c5a3dec30813$var$vb = $0581c5a3dec30813$var$w('<table hidden><tr id="'), $0581c5a3dec30813$var$wb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$xb = $0581c5a3dec30813$var$w("</tr></table>"), $0581c5a3dec30813$var$yb = $0581c5a3dec30813$var$w('<table hidden><colgroup id="'), $0581c5a3dec30813$var$zb = $0581c5a3dec30813$var$w('">'), $0581c5a3dec30813$var$Ab = $0581c5a3dec30813$var$w("</colgroup></table>");
function $0581c5a3dec30813$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$gb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$hb);
        case 2:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$jb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$kb);
        case 3:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$mb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$nb);
        case 4:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$pb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$qb);
        case 5:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$sb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$tb);
        case 6:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$vb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$wb);
        case 7:
            return $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$yb), $0581c5a3dec30813$var$p(a, b.segmentPrefix), $0581c5a3dec30813$var$p(a, $0581c5a3dec30813$var$u(d.toString(16))), $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$zb);
        default:
            throw Error($0581c5a3dec30813$var$k(397));
    }
}
function $0581c5a3dec30813$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ib);
        case 2:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$lb);
        case 3:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ob);
        case 4:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$rb);
        case 5:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$ub);
        case 6:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$xb);
        case 7:
            return $0581c5a3dec30813$var$t(a, $0581c5a3dec30813$var$Ab);
        default:
            throw Error($0581c5a3dec30813$var$k(397));
    }
}
var $0581c5a3dec30813$var$Db = $0581c5a3dec30813$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $0581c5a3dec30813$var$Eb = $0581c5a3dec30813$var$w('$RS("'), $0581c5a3dec30813$var$Gb = $0581c5a3dec30813$var$w('","'), $0581c5a3dec30813$var$Hb = $0581c5a3dec30813$var$w('")\x3c/script>'), $0581c5a3dec30813$var$Ib = $0581c5a3dec30813$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $0581c5a3dec30813$var$Jb = $0581c5a3dec30813$var$w('$RC("'), $0581c5a3dec30813$var$Kb = $0581c5a3dec30813$var$w('","'), $0581c5a3dec30813$var$Lb = $0581c5a3dec30813$var$w('")\x3c/script>'), $0581c5a3dec30813$var$Mb = $0581c5a3dec30813$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $0581c5a3dec30813$var$Nb = $0581c5a3dec30813$var$w('$RX("'), $0581c5a3dec30813$var$Ob = $0581c5a3dec30813$var$w('"'), $0581c5a3dec30813$var$Pb = $0581c5a3dec30813$var$w(")\x3c/script>"), $0581c5a3dec30813$var$Qb = $0581c5a3dec30813$var$w(","), $0581c5a3dec30813$var$Rb = /[<\u2028\u2029]/g;
function $0581c5a3dec30813$var$Sb(a) {
    return JSON.stringify(a).replace($0581c5a3dec30813$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $0581c5a3dec30813$var$N = Object.assign, $0581c5a3dec30813$var$Tb = Symbol.for("react.element"), $0581c5a3dec30813$var$Ub = Symbol.for("react.portal"), $0581c5a3dec30813$var$Vb = Symbol.for("react.fragment"), $0581c5a3dec30813$var$Wb = Symbol.for("react.strict_mode"), $0581c5a3dec30813$var$Xb = Symbol.for("react.profiler"), $0581c5a3dec30813$var$Yb = Symbol.for("react.provider"), $0581c5a3dec30813$var$Zb = Symbol.for("react.context"), $0581c5a3dec30813$var$$b = Symbol.for("react.forward_ref"), $0581c5a3dec30813$var$ac = Symbol.for("react.suspense"), $0581c5a3dec30813$var$bc = Symbol.for("react.suspense_list"), $0581c5a3dec30813$var$cc = Symbol.for("react.memo"), $0581c5a3dec30813$var$dc = Symbol.for("react.lazy"), $0581c5a3dec30813$var$ec = Symbol.for("react.scope"), $0581c5a3dec30813$var$fc = Symbol.for("react.debug_trace_mode"), $0581c5a3dec30813$var$gc = Symbol.for("react.legacy_hidden"), $0581c5a3dec30813$var$hc = Symbol.for("react.default_value"), $0581c5a3dec30813$var$ic = Symbol.iterator;
function $0581c5a3dec30813$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0581c5a3dec30813$var$Vb:
            return "Fragment";
        case $0581c5a3dec30813$var$Ub:
            return "Portal";
        case $0581c5a3dec30813$var$Xb:
            return "Profiler";
        case $0581c5a3dec30813$var$Wb:
            return "StrictMode";
        case $0581c5a3dec30813$var$ac:
            return "Suspense";
        case $0581c5a3dec30813$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0581c5a3dec30813$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $0581c5a3dec30813$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $0581c5a3dec30813$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0581c5a3dec30813$var$cc:
            return b = a.displayName || null, null !== b ? b : $0581c5a3dec30813$var$jc(a.type) || "Memo";
        case $0581c5a3dec30813$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $0581c5a3dec30813$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $0581c5a3dec30813$var$kc = {};
function $0581c5a3dec30813$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $0581c5a3dec30813$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $0581c5a3dec30813$var$O = null;
function $0581c5a3dec30813$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($0581c5a3dec30813$var$k(401));
        } else {
            if (null === c) throw Error($0581c5a3dec30813$var$k(401));
            $0581c5a3dec30813$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $0581c5a3dec30813$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $0581c5a3dec30813$var$mc(a);
}
function $0581c5a3dec30813$var$nc(a) {
    var b = a.parent;
    null !== b && $0581c5a3dec30813$var$nc(b);
    a.context._currentValue = a.value;
}
function $0581c5a3dec30813$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($0581c5a3dec30813$var$k(402));
    a.depth === b.depth ? $0581c5a3dec30813$var$P(a, b) : $0581c5a3dec30813$var$oc(a, b);
}
function $0581c5a3dec30813$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($0581c5a3dec30813$var$k(402));
    a.depth === c.depth ? $0581c5a3dec30813$var$P(a, c) : $0581c5a3dec30813$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $0581c5a3dec30813$var$Q(a) {
    var b = $0581c5a3dec30813$var$O;
    b !== a && (null === b ? $0581c5a3dec30813$var$nc(a) : null === a ? $0581c5a3dec30813$var$mc(b) : b.depth === a.depth ? $0581c5a3dec30813$var$P(b, a) : b.depth > a.depth ? $0581c5a3dec30813$var$oc(b, a) : $0581c5a3dec30813$var$pc(b, a), $0581c5a3dec30813$var$O = a);
}
var $0581c5a3dec30813$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $0581c5a3dec30813$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $0581c5a3dec30813$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $0581c5a3dec30813$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $0581c5a3dec30813$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $0581c5a3dec30813$var$N({}, e, h)) : $0581c5a3dec30813$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $0581c5a3dec30813$var$sc = {
    id: 1,
    overflow: ""
};
function $0581c5a3dec30813$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $0581c5a3dec30813$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $0581c5a3dec30813$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $0581c5a3dec30813$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $0581c5a3dec30813$var$uc = Math.clz32 ? Math.clz32 : $0581c5a3dec30813$var$vc, $0581c5a3dec30813$var$wc = Math.log, $0581c5a3dec30813$var$xc = Math.LN2;
function $0581c5a3dec30813$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0581c5a3dec30813$var$wc(a) / $0581c5a3dec30813$var$xc | 0) | 0;
}
function $0581c5a3dec30813$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0581c5a3dec30813$var$zc = "function" === typeof Object.is ? Object.is : $0581c5a3dec30813$var$yc, $0581c5a3dec30813$var$R = null, $0581c5a3dec30813$var$Ac = null, $0581c5a3dec30813$var$Bc = null, $0581c5a3dec30813$var$S = null, $0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$Cc = !1, $0581c5a3dec30813$var$U = 0, $0581c5a3dec30813$var$V = null, $0581c5a3dec30813$var$Dc = 0;
function $0581c5a3dec30813$var$W() {
    if (null === $0581c5a3dec30813$var$R) throw Error($0581c5a3dec30813$var$k(321));
    return $0581c5a3dec30813$var$R;
}
function $0581c5a3dec30813$var$Ec() {
    if (0 < $0581c5a3dec30813$var$Dc) throw Error($0581c5a3dec30813$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $0581c5a3dec30813$var$Fc() {
    null === $0581c5a3dec30813$var$S ? null === $0581c5a3dec30813$var$Bc ? ($0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$Bc = $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Ec()) : ($0581c5a3dec30813$var$T = !0, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Bc) : null === $0581c5a3dec30813$var$S.next ? ($0581c5a3dec30813$var$T = !1, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$S.next = $0581c5a3dec30813$var$Ec()) : ($0581c5a3dec30813$var$T = !0, $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$S.next);
    return $0581c5a3dec30813$var$S;
}
function $0581c5a3dec30813$var$Gc() {
    $0581c5a3dec30813$var$Ac = $0581c5a3dec30813$var$R = null;
    $0581c5a3dec30813$var$Cc = !1;
    $0581c5a3dec30813$var$Bc = null;
    $0581c5a3dec30813$var$Dc = 0;
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$V = null;
}
function $0581c5a3dec30813$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0581c5a3dec30813$var$Ic(a, b, c) {
    $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
    if ($0581c5a3dec30813$var$T) {
        var d = $0581c5a3dec30813$var$S.queue;
        b = d.dispatch;
        if (null !== $0581c5a3dec30813$var$V && (c = $0581c5a3dec30813$var$V.get(d), void 0 !== c)) {
            $0581c5a3dec30813$var$V.delete(d);
            d = $0581c5a3dec30813$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $0581c5a3dec30813$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $0581c5a3dec30813$var$S.memoizedState,
            b
        ];
    }
    a = a === $0581c5a3dec30813$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $0581c5a3dec30813$var$S.memoizedState = a;
    a = $0581c5a3dec30813$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $0581c5a3dec30813$var$Jc.bind(null, $0581c5a3dec30813$var$R, a);
    return [
        $0581c5a3dec30813$var$S.memoizedState,
        a
    ];
}
function $0581c5a3dec30813$var$Kc(a, b) {
    $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
    $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $0581c5a3dec30813$var$S) {
        var c = $0581c5a3dec30813$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$0581c5a3dec30813$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $0581c5a3dec30813$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0581c5a3dec30813$var$Jc(a, b, c) {
    if (25 <= $0581c5a3dec30813$var$Dc) throw Error($0581c5a3dec30813$var$k(301));
    if (a === $0581c5a3dec30813$var$R) {
        if ($0581c5a3dec30813$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $0581c5a3dec30813$var$V && ($0581c5a3dec30813$var$V = new Map), c = $0581c5a3dec30813$var$V.get(b), void 0 === c) $0581c5a3dec30813$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $0581c5a3dec30813$var$Lc() {
    throw Error($0581c5a3dec30813$var$k(394));
}
function $0581c5a3dec30813$var$Mc() {}
var $0581c5a3dec30813$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $0581c5a3dec30813$var$W();
        return a._currentValue;
    },
    useMemo: $0581c5a3dec30813$var$Kc,
    useReducer: $0581c5a3dec30813$var$Ic,
    useRef: function(a) {
        $0581c5a3dec30813$var$R = $0581c5a3dec30813$var$W();
        $0581c5a3dec30813$var$S = $0581c5a3dec30813$var$Fc();
        var b = $0581c5a3dec30813$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $0581c5a3dec30813$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $0581c5a3dec30813$var$Ic($0581c5a3dec30813$var$Hc, a);
    },
    useInsertionEffect: $0581c5a3dec30813$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $0581c5a3dec30813$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $0581c5a3dec30813$var$Mc,
    useEffect: $0581c5a3dec30813$var$Mc,
    useDebugValue: $0581c5a3dec30813$var$Mc,
    useDeferredValue: function(a) {
        $0581c5a3dec30813$var$W();
        return a;
    },
    useTransition: function() {
        $0581c5a3dec30813$var$W();
        return [
            !1,
            $0581c5a3dec30813$var$Lc
        ];
    },
    useId: function() {
        var a = $0581c5a3dec30813$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $0581c5a3dec30813$var$uc(a) - 1)).toString(32) + b;
        var c = $0581c5a3dec30813$var$Nc;
        if (null === c) throw Error($0581c5a3dec30813$var$k(404));
        b = $0581c5a3dec30813$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $0581c5a3dec30813$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($0581c5a3dec30813$var$k(407));
        return c();
    }
}, $0581c5a3dec30813$var$Nc = null, $0581c5a3dec30813$var$Pc = $eJOHy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $0581c5a3dec30813$var$Qc(a) {
    console.error(a);
    return null;
}
function $0581c5a3dec30813$var$X() {}
function $0581c5a3dec30813$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $0581c5a3dec30813$var$Qc : f,
        onAllReady: void 0 === e ? $0581c5a3dec30813$var$X : e,
        onShellReady: void 0 === g ? $0581c5a3dec30813$var$X : g,
        onShellError: void 0 === h ? $0581c5a3dec30813$var$X : h,
        onFatalError: void 0 === m ? $0581c5a3dec30813$var$X : m
    };
    c = $0581c5a3dec30813$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $0581c5a3dec30813$var$Tc(b, a, null, c, r, $0581c5a3dec30813$var$kc, null, $0581c5a3dec30813$var$sc);
    q.push(a);
    return b;
}
function $0581c5a3dec30813$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $0581c5a3dec30813$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $0581c5a3dec30813$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $0581c5a3dec30813$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $0581c5a3dec30813$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $0581c5a3dec30813$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $0581c5a3dec30813$var$Wc(a, b, c, d, f) {
    $0581c5a3dec30813$var$R = {};
    $0581c5a3dec30813$var$Ac = b;
    $0581c5a3dec30813$var$U = 0;
    for(a = c(d, f); $0581c5a3dec30813$var$Cc;)$0581c5a3dec30813$var$Cc = !1, $0581c5a3dec30813$var$U = 0, $0581c5a3dec30813$var$Dc += 1, $0581c5a3dec30813$var$S = null, a = c(d, f);
    $0581c5a3dec30813$var$Gc();
    return a;
}
function $0581c5a3dec30813$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($0581c5a3dec30813$var$k(108, $0581c5a3dec30813$var$jc(d) || "Unknown", h));
            d = $0581c5a3dec30813$var$N({}, g, c);
        }
        b.legacyContext = d;
        $0581c5a3dec30813$var$Z(a, b, f);
        b.legacyContext = g;
    } else $0581c5a3dec30813$var$Z(a, b, f);
}
function $0581c5a3dec30813$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $0581c5a3dec30813$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0581c5a3dec30813$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $0581c5a3dec30813$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $0581c5a3dec30813$var$rc(e, c, d, f);
            $0581c5a3dec30813$var$Xc(a, b, e, c);
        } else {
            e = $0581c5a3dec30813$var$lc(c, b.legacyContext);
            f = $0581c5a3dec30813$var$Wc(a, b, c, d, e);
            var g = 0 !== $0581c5a3dec30813$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $0581c5a3dec30813$var$rc(f, c, d, e), $0581c5a3dec30813$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $0581c5a3dec30813$var$tc(d, 1, 0);
                try {
                    $0581c5a3dec30813$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $0581c5a3dec30813$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $0581c5a3dec30813$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $0581c5a3dec30813$var$Ba(g, c, d);
        $0581c5a3dec30813$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($0581c5a3dec30813$var$Ta, $0581c5a3dec30813$var$u(c), $0581c5a3dec30813$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $0581c5a3dec30813$var$gc:
            case $0581c5a3dec30813$var$fc:
            case $0581c5a3dec30813$var$Wb:
            case $0581c5a3dec30813$var$Xb:
            case $0581c5a3dec30813$var$Vb:
                $0581c5a3dec30813$var$Z(a, b, d.children);
                return;
            case $0581c5a3dec30813$var$bc:
                $0581c5a3dec30813$var$Z(a, b, d.children);
                return;
            case $0581c5a3dec30813$var$ec:
                throw Error($0581c5a3dec30813$var$k(343));
            case $0581c5a3dec30813$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $0581c5a3dec30813$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $0581c5a3dec30813$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($0581c5a3dec30813$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($0581c5a3dec30813$var$Ca), q.status = 1, $0581c5a3dec30813$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $0581c5a3dec30813$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $0581c5a3dec30813$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $0581c5a3dec30813$var$$b:
                d = $0581c5a3dec30813$var$Wc(a, b, c.render, d, f);
                if (0 !== $0581c5a3dec30813$var$U) {
                    c = b.treeContext;
                    b.treeContext = $0581c5a3dec30813$var$tc(c, 1, 0);
                    try {
                        $0581c5a3dec30813$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $0581c5a3dec30813$var$Z(a, b, d);
                return;
            case $0581c5a3dec30813$var$cc:
                c = c.type;
                d = $0581c5a3dec30813$var$Yc(c, d);
                $0581c5a3dec30813$var$Zc(a, b, c, d, f);
                return;
            case $0581c5a3dec30813$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $0581c5a3dec30813$var$O;
                $0581c5a3dec30813$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $0581c5a3dec30813$var$Z(a, b, f);
                a = $0581c5a3dec30813$var$O;
                if (null === a) throw Error($0581c5a3dec30813$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $0581c5a3dec30813$var$hc ? a.context._defaultValue : d;
                a = $0581c5a3dec30813$var$O = a.parent;
                b.context = a;
                return;
            case $0581c5a3dec30813$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $0581c5a3dec30813$var$Z(a, b, d);
                return;
            case $0581c5a3dec30813$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $0581c5a3dec30813$var$Yc(c, d);
                $0581c5a3dec30813$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($0581c5a3dec30813$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $0581c5a3dec30813$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $0581c5a3dec30813$var$Tb:
                $0581c5a3dec30813$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $0581c5a3dec30813$var$Ub:
                throw Error($0581c5a3dec30813$var$k(257));
            case $0581c5a3dec30813$var$dc:
                var d = c._init;
                c = d(c._payload);
                $0581c5a3dec30813$var$Z(a, b, c);
                return;
        }
        if ($0581c5a3dec30813$var$ra(c)) {
            $0581c5a3dec30813$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $0581c5a3dec30813$var$ic && c[$0581c5a3dec30813$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $0581c5a3dec30813$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($0581c5a3dec30813$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $0581c5a3dec30813$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $0581c5a3dec30813$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $0581c5a3dec30813$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $0581c5a3dec30813$var$tc(e, d, f);
        try {
            $0581c5a3dec30813$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $0581c5a3dec30813$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $0581c5a3dec30813$var$Z(a, b, c);
    } catch (m) {
        if ($0581c5a3dec30813$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $0581c5a3dec30813$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $0581c5a3dec30813$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $0581c5a3dec30813$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $0581c5a3dec30813$var$Q(e), m;
    }
}
function $0581c5a3dec30813$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $0581c5a3dec30813$var$dd(this, b, a);
}
function $0581c5a3dec30813$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($0581c5a3dec30813$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $0581c5a3dec30813$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $0581c5a3dec30813$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $0581c5a3dec30813$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $0581c5a3dec30813$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($0581c5a3dec30813$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $0581c5a3dec30813$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $0581c5a3dec30813$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($0581c5a3dec30813$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($0581c5a3dec30813$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $0581c5a3dec30813$var$Uc(a) {
    if (2 !== a.status) {
        var b = $0581c5a3dec30813$var$O, c = $0581c5a3dec30813$var$Pc.current;
        $0581c5a3dec30813$var$Pc.current = $0581c5a3dec30813$var$Oc;
        var d = $0581c5a3dec30813$var$Nc;
        $0581c5a3dec30813$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $0581c5a3dec30813$var$Q(g.context);
                    try {
                        $0581c5a3dec30813$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($0581c5a3dec30813$var$Ca), g.abortSet.delete(g), m.status = 1, $0581c5a3dec30813$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($0581c5a3dec30813$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $0581c5a3dec30813$var$Y(h, v);
                            null === r ? $0581c5a3dec30813$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $0581c5a3dec30813$var$fd(a, a.destination);
        } catch (G) {
            $0581c5a3dec30813$var$Y(a, G), $0581c5a3dec30813$var$Vc(a, G);
        } finally{
            $0581c5a3dec30813$var$Nc = d, $0581c5a3dec30813$var$Pc.current = c, c === $0581c5a3dec30813$var$Oc && $0581c5a3dec30813$var$Q(b);
        }
    }
}
function $0581c5a3dec30813$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Va);
            $0581c5a3dec30813$var$p(b, a.placeholderPrefix);
            a = $0581c5a3dec30813$var$u(d.toString(16));
            $0581c5a3dec30813$var$p(b, a);
            return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$0581c5a3dec30813$var$p(b, d[e]);
                f = $0581c5a3dec30813$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$0581c5a3dec30813$var$p(b, d[e]);
            e < d.length && (f = $0581c5a3dec30813$var$t(b, d[e]));
            return f;
        default:
            throw Error($0581c5a3dec30813$var$k(390));
    }
}
function $0581c5a3dec30813$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $0581c5a3dec30813$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$$a), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$bb), d && ($0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$db), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$C(d))), $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$cb)), $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$eb), $0581c5a3dec30813$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $0581c5a3dec30813$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $0581c5a3dec30813$var$fb(b, a.responseState, d);
        $0581c5a3dec30813$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $0581c5a3dec30813$var$fb(b, a.responseState, d.id), $0581c5a3dec30813$var$gd(a, b, c);
    else {
        $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($0581c5a3dec30813$var$k(391));
        $0581c5a3dec30813$var$hd(a, b, c[0]);
    }
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$ab);
}
function $0581c5a3dec30813$var$id(a, b, c) {
    $0581c5a3dec30813$var$Bb(b, a.responseState, c.formatContext, c.id);
    $0581c5a3dec30813$var$hd(a, b, c);
    return $0581c5a3dec30813$var$Cb(b, c.formatContext);
}
function $0581c5a3dec30813$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$0581c5a3dec30813$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $0581c5a3dec30813$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Ib));
    if (null === d) throw Error($0581c5a3dec30813$var$k(395));
    c = $0581c5a3dec30813$var$u(c.toString(16));
    $0581c5a3dec30813$var$p(b, d);
    $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Kb);
    $0581c5a3dec30813$var$p(b, a.segmentPrefix);
    $0581c5a3dec30813$var$p(b, c);
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Lb);
}
function $0581c5a3dec30813$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($0581c5a3dec30813$var$k(392));
        return $0581c5a3dec30813$var$id(a, b, d);
    }
    $0581c5a3dec30813$var$id(a, b, d);
    a = a.responseState;
    $0581c5a3dec30813$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Eb) : (a.sentCompleteSegmentFunction = !0, $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Db));
    $0581c5a3dec30813$var$p(b, a.segmentPrefix);
    f = $0581c5a3dec30813$var$u(f.toString(16));
    $0581c5a3dec30813$var$p(b, f);
    $0581c5a3dec30813$var$p(b, $0581c5a3dec30813$var$Gb);
    $0581c5a3dec30813$var$p(b, a.placeholderPrefix);
    $0581c5a3dec30813$var$p(b, f);
    return $0581c5a3dec30813$var$t(b, $0581c5a3dec30813$var$Hb);
}
function $0581c5a3dec30813$var$fd(a, b) {
    $0581c5a3dec30813$var$l = new Uint8Array(512);
    $0581c5a3dec30813$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $0581c5a3dec30813$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$0581c5a3dec30813$var$p(b, d[c]);
            c < d.length && $0581c5a3dec30813$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $0581c5a3dec30813$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Nb) : (h.sentClientRenderFunction = !0, $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Mb));
            if (null === m) throw Error($0581c5a3dec30813$var$k(395));
            $0581c5a3dec30813$var$p(d, m);
            $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Ob);
            if (q || r || v) $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(q || "")));
            if (r || v) $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(r || "")));
            v && ($0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$Qb), $0581c5a3dec30813$var$p(d, $0581c5a3dec30813$var$u($0581c5a3dec30813$var$Sb(v))));
            if (!$0581c5a3dec30813$var$t(d, $0581c5a3dec30813$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$0581c5a3dec30813$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $0581c5a3dec30813$var$ba(b);
        $0581c5a3dec30813$var$l = new Uint8Array(512);
        $0581c5a3dec30813$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$0581c5a3dec30813$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$0581c5a3dec30813$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $0581c5a3dec30813$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $0581c5a3dec30813$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $0581c5a3dec30813$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $0581c5a3dec30813$var$fd(a, a.destination);
    } catch (d) {
        $0581c5a3dec30813$var$Y(a, d), $0581c5a3dec30813$var$Vc(a, d);
    }
}
$0581c5a3dec30813$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $0581c5a3dec30813$var$Rc(a, $0581c5a3dec30813$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $0581c5a3dec30813$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $0581c5a3dec30813$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $0581c5a3dec30813$var$fd(h, a);
                        } catch (A) {
                            $0581c5a3dec30813$var$Y(h, A), $0581c5a3dec30813$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $0581c5a3dec30813$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $0581c5a3dec30813$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $0581c5a3dec30813$var$Uc(h);
    });
};
$0581c5a3dec30813$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("lsQfa", function(module, exports) {

$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $df01c34547b537c0$export$99df83ca0f45bd54);

var $6T1aH = parcelRequire("6T1aH");
const $df01c34547b537c0$export$99df83ca0f45bd54 = [
    (0, $6T1aH.PreferenceCategory).Analytics,
    (0, $6T1aH.PreferenceCategory).Functional,
    (0, $6T1aH.PreferenceCategory).Marketing,
    (0, $6T1aH.PreferenceCategory).StrictlyNecessary,
    (0, $6T1aH.PreferenceCategory).Unknown
];

});

parcelRegister("ANFiK", function(module, exports) {

$parcel$export(module.exports, "CookieCategorySection", () => $b1dfa5635830644a$export$3c97a3b492e10ae9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lgusX = parcelRequire("lgusX");

var $6T1aH = parcelRequire("6T1aH");
const $b1dfa5635830644a$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $b1dfa5635830644a$var$categoryBoxStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.200'
});
const $b1dfa5635830644a$var$categoryDescriptionStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $b1dfa5635830644a$var$categoryToEventSubjectMap = {
    [(0, $6T1aH.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $6T1aH.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $6T1aH.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $6T1aH.PreferenceCategory).Unknown]: null
};
const $b1dfa5635830644a$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $eJOHy.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $6T1aH.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $b1dfa5635830644a$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $lgusX.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: $b1dfa5635830644a$var$categoryBoxStyles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                className: `${$b1dfa5635830644a$var$tmpTrelloClassNameOverride}`,
                isChecked: isChecked,
                value: isChecked.toString(),
                onChange: onCheckboxChange,
                label: titleElement,
                name: `${titleString}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $b1dfa5635830644a$var$categoryDescriptionStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    size: "UNSAFE_small",
                    color: "color.text.subtle",
                    children: descriptionElement
                })
            })
        ]
    });
};

});
parcelRegister("86tBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("csN0I", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $67bf7565969024bf$export$a7357cdd1f0b0168);

var $7qGN1 = parcelRequire("7qGN1");
const $67bf7565969024bf$export$a7357cdd1f0b0168 = (0, $7qGN1.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'Cookie preferences modal dialog title.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    }
});

});


parcelRegister("bydzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c969d3d3c1674774$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eCCyA = parcelRequire("eCCyA");

var $9UP3e = parcelRequire("9UP3e");

var $4kOzQ = parcelRequire("4kOzQ");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $c969d3d3c1674774$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $9UP3e.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $c969d3d3c1674774$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
	 * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
	 *  during the initial render. Without this flag, the application might incorrectly display a banner based on
	 * incomplete or missing preference data. During the rehydration process, this initial render triggers
	 * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
	 * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
	 * and the client-rendered state.
	 */ const isInitialRender = (0, $eJOHy.useRef)(true);
    const prefetchedPreferencesData = (0, $eJOHy.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $eJOHy.useState)((0, $eCCyA.initializePreferencesData)(initialPreferences));
    (0, $eJOHy.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $eCCyA.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $4kOzQ.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $c969d3d3c1674774$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $c969d3d3c1674774$export$2e2bcd8739ae039 = $c969d3d3c1674774$var$usePreferences;

});


parcelRegister("3TuNG", function(module, exports) {

$parcel$export(module.exports, "PresentationalConsentBanner", () => $99d6a25f57ce38a5$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $goZPP = parcelRequire("goZPP");

var $entZ3 = parcelRequire("entZ3");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6efFi = parcelRequire("6efFi");

var $lsQfa = parcelRequire("lsQfa");

var $6KMc4 = parcelRequire("6KMc4");
const $99d6a25f57ce38a5$var$boxStylesBlueWithMinHeight = (0, $1DXK0.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.information',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $99d6a25f57ce38a5$var$inlineWrapperStyles = (0, $1DXK0.xcss)({
    // Small viewport defaults
    gap: 'space.200',
    alignItems: 'flex-start',
    flexDirection: 'column',
    // Larger viewports
    [(0, $6efFi.media).above.sm]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $99d6a25f57ce38a5$var$noticeContainerStyles = (0, $1DXK0.xcss)({
    flexDirection: 'column'
});
const $99d6a25f57ce38a5$var$buttonContainerStyles = (0, $1DXK0.xcss)({
    // Prevents the button text from truncating when the screen width decreases
    minWidth: 'fit-content',
    // Applies to below sm size
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $6efFi.media).above.sm]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $99d6a25f57ce38a5$var$noop = ()=>{};
const $99d6a25f57ce38a5$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $lsQfa.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $6KMc4.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $6KMc4.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $99d6a25f57ce38a5$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $6KMc4.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $6KMc4.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $99d6a25f57ce38a5$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $99d6a25f57ce38a5$var$noop, onClickAcceptAll: onClickAcceptAll = $99d6a25f57ce38a5$var$noop, onClickPreferences: onClickPreferences = $99d6a25f57ce38a5$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $99d6a25f57ce38a5$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 74 })=>{
    const intl = (0, $lRq8t.default)();
    const displayedTextMap = (0, $eJOHy.useMemo)(()=>{
        return $99d6a25f57ce38a5$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $eJOHy.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $99d6a25f57ce38a5$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $eJOHy.useCallback)(()=>{
        const displayedTextAcceptAllMap = $99d6a25f57ce38a5$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $99d6a25f57ce38a5$var$boxStylesBlueWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            xcss: $99d6a25f57ce38a5$var$inlineWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
                    xcss: $99d6a25f57ce38a5$var$noticeContainerStyles,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $6KMc4.i18n).useCookiesDescription,
                        tagName: "span",
                        values: {
                            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lL4G9.default), {
                                id: "cookiesTrackingNoticeLink",
                                href: "https://www.atlassian.com/legal/cookies",
                                target: "_blank",
                                onClick: onClickTrackingNoticeLink,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                    ...(0, $6KMc4.i18n).cookiesTrackingNotice
                                })
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                    space: "space.100",
                    xcss: $99d6a25f57ce38a5$var$buttonContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            appearance: "subtle",
                            onClick: onClickPreferences,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $6KMc4.i18n).preferencesBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            onClick: handleOnlyNecessaryClick,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $6KMc4.i18n).onlyNecessaryBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
                                color: "currentColor",
                                spacing: "none",
                                testId: "experiment-one-button-icon",
                                label: ""
                            }),
                            onClick: handleAcceptAllClick,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $6KMc4.i18n).acceptAllBtn
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1b17ecff78f4ff04$var$_checkMark = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("lwpci")));
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1b17ecff78f4ff04$var$_checkMark.default
    }));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});



parcelRegister("fN2qH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a675048897a3049$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $eJOHy = parcelRequire("eJOHy");

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $cnsbg = parcelRequire("cnsbg");

var $2hz3A = parcelRequire("2hz3A");

var $5Qndl = parcelRequire("5Qndl");

var $2p0jb = parcelRequire("2p0jb");

var $9EknI = parcelRequire("9EknI");
const $8a675048897a3049$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if ((0, $cnsbg.isSSR)() || inFlowWhereBannerStateIsUnknown) // When coming from SSR, this hook will only execute once and won't update later
    // Instead, if we're on the server, have initial preference data with valid consents, don't render
    // On later checks (rehydration), this will always fail and skip to the normal rendering logic
    // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
    // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
    // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
    return (0, $9EknI.shouldShowBannerInSSRContext)(initialPreferences);
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $8a675048897a3049$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState })=>{
    const isEventSent = (0, $eJOHy.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $eJOHy.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $5Qndl.setStrictlyNecessaryCookie)((0, $2hz3A.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $eJOHy.useMemo)(()=>{
        return $8a675048897a3049$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $lgusX.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $8a675048897a3049$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed })=>{
    if ((0, $9SIye.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((0, $cnsbg.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $8a675048897a3049$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $8a675048897a3049$export$2e2bcd8739ae039 = $8a675048897a3049$var$useBannerVisibility;

});
parcelRegister("9EknI", function(module, exports) {

$parcel$export(module.exports, "shouldShowBannerInSSRContext", () => $a2ac5032c17787a1$export$1a7f5824c34ba94b);

var $eGOwo = parcelRequire("eGOwo");

var $eCCyA = parcelRequire("eCCyA");

var $eLZEM = parcelRequire("eLZEM");

var $6T1aH = parcelRequire("6T1aH");
const $a2ac5032c17787a1$export$1a7f5824c34ba94b = (initialPreferences)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If our bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (initialPreferences === (0, $6T1aH.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
    // if the user has consented or not yet since we need to fetch, so show the banner
    return true;
    // Confluence the banner will render on the UI, so we should plan to render here too
    if (!initialPreferences || (0, $eCCyA.initialPreferencesAreMissing)(initialPreferences)) return true;
    // If prefetched data has a consentToken or the consents array is there and populated
    // we want to hide the banner, as the user has has made consents already.
    const prefetchedToken = 'consentToken' in initialPreferences && initialPreferences.consentToken;
    const prefetchedTokenIsDefault = (0, $eLZEM.checkIfTokenIsDefault)(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in initialPreferences && initialPreferences.consents;
    const hasLegitConsents = prefetchedConsents && prefetchedConsents.length > 0;
    const prefetchedDataHasConsents = Boolean(hasLegitConsentToken || hasLegitConsents);
    const showBannerSinceUserHasNotConsented = !prefetchedDataHasConsents;
    return showBannerSinceUserHasNotConsented;
};

});


parcelRegister("d5pSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3d9694628388ad$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $aa3d9694628388ad$var$usePrevious = (value)=>{
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = (0, $eJOHy.useRef)();
    // Store current value in ref
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
var $aa3d9694628388ad$export$2e2bcd8739ae039 = $aa3d9694628388ad$var$usePrevious;

});



const $5dc1b04ccd518917$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $5dc1b04ccd518917$export$ed7cc0d417ee89e = 74;
const $5dc1b04ccd518917$export$ff6e18f7d82b549c = 320;



//# sourceMappingURL=async-cc-banner.8dfc29de.js.map
